function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * qd.jssdk.js v4.0.10
 * (c) 2024 Zhang Chengrong
 * Released under the MIT License.
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : (global = global || self, global.jssdk = factory());
})(this, function () {
  'use strict';
  /**
   * @module core
   * @description 核心模块
   */

  /* eslint-disable max-len */
  // Mozilla/5.0 (Linux; Android 4.4.4; en-us; Nexus 5 Build/JOP40D) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/42.0.2307.2 Mobile Safari/537.36

  var REG_ANDROID = /\bAndroid ([\d.]+)/; // iPhone: Mozilla/5.0 (iPhone; CPU iPhone OS 8_0 like Mac OS X) AppleWebKit/600.1.3 (KHTML, like Gecko) Version/8.0 Mobile/12A4345d Safari/600.1.4
  // 老iPad:   Mozilla/5.0 (iPad; CPU OS 7_0 like Mac OS X) AppleWebKit/537.51.1 (KHTML, like Gecko) Version/7.0 Mobile/11A465 Safari/9537.53

  var REG_IOS = /\b(iPad|iPhone|iPod)\b.*? OS ([\d_]+)/; // 新iPad: Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_4) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/13.1.1 Safari/605.1.15

  var REG_MACOS_VERSION = /Mac OS X\s+(\d+_\d+_\d+)/; // 匹配 newPad macOS版本号
  // Mozilla/5.0 (Phone; OpenHarmony 5.0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/114.0.0.0 Safari/537.36  ArkWeb/4.1.6.1 Mobile QDJSSDK/1.0 QDNightStyle_1 QDReaderHarmonyOS/1.1.101/10100101/cepingtuan/HUAWEI

  var REG_HARMONY = /\bOpenHarmony ([\d.]+)/;
  /**
   * @description 接口不支持状态码
   * @example
   * jssdk.invokeClient('app', 'openBook', { bookId: 1115277 }, function (result) {
   *   if (result.code === jssdk.CODE_NOT_SUPPORT) {
   *     return 'http://m.qidian.com/book/1115277';
   *   }
   * });
   */

  var CODE_NOT_SUPPORT = 1010;
  /* eslint-enable max-len */
  // 客户端正则

  var REG_ANDROID_CLIENT = /\bQDReaderAndroid\/([\d.]+)\/(\d+)/;
  var REG_IPAD_CLIENT = /\/QDReaderiPad\/([\d.]+)\/(\d+)/;
  var REG_IPHONE_CLIENT = /\/QDReaderiOS\/([\d.]+)\/(\d+)/;
  var REG_HARMONY_CLIENT = /\bQDReaderHarmonyOS\/([\d.]+)\/(\d+)/; // 工具方法

  var isArray = Array.isArray;

  var isDefined = function isDefined(obj) {
    return typeof obj !== 'undefined';
  };

  var isFunction = function isFunction(obj) {
    return typeof obj === 'function';
  };

  var isObject = function isObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
  };

  var isString = function isString(str) {
    return typeof str === 'string';
  };

  var noop = function noop(d) {
    return d;
  };

  var callbackUUID = 10000; // 回调方法唯一序号, 10000 以下用于预留固定方法

  var callbackIdGenerator = function callbackIdGenerator() {
    return ++callbackUUID;
  }; // 回调方法ID生成器


  var apiSupports = {}; // 缓存所有 api support

  var apiFunctions = {}; // 缓存所有 api function

  var apiEvents = {}; // 缓存所有 api eventName

  var allCallbacks = {
    // 缓存所有回调方法
    10: function _() {
      // 用于需要刷新当前页面的接口
      location.reload();
    }
  };
  var ua = navigator.userAgent;
  /**
   * @attribute isAndroid
   * @description 如果在 android 中，值为 true，否则为 false
   */

  var isAndroid = REG_ANDROID.test(ua);
  /**
   * @attribute isIOS
   * @description 如果在 iOS 中，值为 true，否则为 false
   */

  var isNewIPad = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1; // ios 13 后的 iPad 新 ua 头

  var isIOS = !isAndroid && (REG_IOS.test(ua) || isNewIPad); // 防止某些安卓机型的 ua 带 iPhone

  /**
   * @attribute isHarmony
   * @description 如果在 HarmonyOS 中，值为 true，否则为 false
   */

  var isHarmony = !isAndroid && !isIOS && REG_HARMONY.test(ua); // 防止某些安卓和 iOS 机型的 ua 带 HarmonyOS

  /**
   * @attribute systemVersion
   * @description 如果在 android 中，值为 android 的系统版本号，如果在 iOS 中，值为 iOS 的系统版本号，否则为 null
   */

  var systemVersionStr;

  try {
    if (isAndroid) {
      systemVersionStr = ua.match(REG_ANDROID)[1];
    } else if (isIOS) {
      if (isNewIPad) {
        // 新 iPad 的系统版本号 不能用 ua.match(REG_IOS)[2] 获取，会变成 null 导致 js 抛错中断，所以先前置判断是不是 新的 Ipad ua 头
        systemVersionStr = ua.match(REG_MACOS_VERSION)[1];
      } else {
        systemVersionStr = ua.match(REG_IOS)[2];
      }
    } else if (isHarmony) {
      systemVersionStr = ua.match(REG_HARMONY)[1];
    } else {
      systemVersionStr = null;
    }
  } catch (e) {
    console.log('获取系统版本号失败', e);
  }

  var systemVersion = systemVersionStr; // 获取客户端平台信息和版本信息

  var clientInfo = function () {
    var plat = 'browser';
    var ver = '0';
    var code = '0';
    var isSup = false;

    if (isAndroid) {
      var androidMatch = ua.match(REG_ANDROID_CLIENT);

      if (androidMatch) {
        plat = 'android';
        ver = androidMatch[1] || ver;
        code = androidMatch[2] || code;
        isSup = compare(ver, '6.4.0') > -1;
      }
    } else if (isIOS) {
      var iPadMatch = ua.match(REG_IPAD_CLIENT);
      var iPhoneMatch = ua.match(REG_IPHONE_CLIENT);

      if (iPadMatch) {
        plat = 'iPad';
        ver = iPadMatch[1] || ver;
        code = iPadMatch[2] || code;
        isSup = compare(ver, '3.7.3') > -1;
      } else if (iPhoneMatch) {
        plat = 'iPhone';
        ver = iPhoneMatch[1] || ver;
        code = iPhoneMatch[2] || code;
        isSup = compare(ver, '3.7.3') > -1;
      }
    } else if (isHarmony) {
      var harmonyMatch = ua.match(REG_HARMONY_CLIENT);

      if (harmonyMatch) {
        plat = 'HarmonyOS';
        ver = harmonyMatch[1] || ver;
        code = harmonyMatch[2] || code;
        isSup = compare(ver, '1.0.0') > -1;
      }
    }

    return {
      plat: plat,
      ver: ver,
      code: code,
      isSup: isSup
    };
  }();
  /**
   * @attribute platform
   * @description 当前运行平台: browser|android|iPad|iPhone|HarmonyOS
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */


  var platform = clientInfo.plat;
  /**
   * @attribute clientVersion
   * @description 客户端版本
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var clientVersion = clientInfo.ver;
  /**
   * @attribute isInBrowser
   * @description 是否在浏览器中
   */

  var isInBrowser = platform === 'browser';
  /**
   * @attribute schema
   * @description 协议头(浏览器: 对应 App 协议头; App: 'jsbridge')
   */

  var schema = isInBrowser ? 'QDReader' : 'jsbridge';
  /**
   * @attribute versionCode
   * @description 客户端版本编号
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var versionCode = clientInfo.code;
  /**
   * @attribute isSupport
   * @description 客户端是否支持jssdk
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var isSupport = clientInfo.isSup;
  /**
   * 比较版本号
   * @param  {String} ver1 - 版本号
   * @param  {String} ver2 - 需要比较的版本号，默认为当前客户端版本号
   * @return {Number} 当 ver1 < ver2 返回-1, 当 ver1 == ver2 返回0, 当 ver1 > ver2 返回1
   *
   * @example <caption>比较"1.0.1"和当前当前客户端大小</caption>
   * console.log(jssdk.compare('1.0.1')); // 返回-1表示小于当前客户端版本，0表示等于当前客户端版本，1表示大于当前客户端版本
   *
   * @example <caption>比较"1.0.1"和"1.0.2"</caption>
   * console.log(jssdk.compare('1.0.1', '1.0.2')); // 返回-1
   */

  function compare(ver1, ver2) {
    if (!ver2) {
      ver2 = clientVersion;
    }

    var arr1 = String(ver1).split('.');
    var arr2 = String(ver2).split('.');
    var len = Math.max(arr1.length, arr2.length);
    var i;
    var l;
    var r;

    for (i = 0; i < len; i++) {
      l = isFinite(arr1[i]) && Number(arr1[i]) || 0;
      r = isFinite(arr2[i]) && Number(arr2[i]) || 0;

      if (l < r) {
        return -1;
      } else if (l > r) {
        return 1;
      }
    }

    return 0;
  }
  /**
   * 检查当前客户端版本是否支持某接口
   * @param  {String} name - 接口名称，格式：module.method
   * @return {Boolean} 返回 true 则表示支持该接口，false 则表示不支持该接口
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   *
   * @example <caption>判断是否支持"device.getSystemVersion"</caption>
   * console.log(jssdk.support('device.getSystemVersion'));
   */


  function support(name) {
    var supportVersion = apiSupports[name];

    if (!isString(supportVersion)) {
      return !!supportVersion;
    }

    var vers = supportVersion.split('-');

    if (vers.length === 2) {
      return compare(vers[0]) < 1 && compare(vers[1]) > -1;
    }

    return compare(vers[0]) < 1;
  }
  /*
   * url 生成器
   * @param  {String} module - 模块
   * @param  {String} method - 方法
   * @param  {Object} params - 参数
   * @param  {Number} callbackId - 回调方法ID
   * @return {String} bridge url
   */


  function urlGenerator(module, method, params, callbackId) {
    var encode = encodeURIComponent; // 经过和客户端约定，以 get 开头的方法在生成 url 的时候去掉 get

    if (method.match(/^get/)) {
      method = method.replace(/^get/, '');
      method = method.slice(0, 1).toLowerCase() + method.slice(1);
    }

    var host = encode(module);
    var port = callbackId ? ":".concat(callbackId) : '';
    var path = encode(method);
    var queryString = params ? "?query=".concat(encode(JSON.stringify(params))) : '';
    return "".concat(schema, "://").concat(host).concat(port, "/").concat(path).concat(queryString);
  }
  /*
   * 定时器生成器
   * @param  {Function} handler - 执行方法
   * @param  {Number} delay - 延迟时间
   * @return {Function} 返回销毁器
   */


  function timerGenerator(handler, delay) {
    var timer = setTimeout(function () {
      timer = null;

      if (isFunction(handler)) {
        handler();
      }
    }, delay);
    return function destroy() {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
    };
  }
  /*
   * iframe 生成器
   * @param  {String} url - iframe地址
   * @return {Function} 返回销毁器
   */


  function iframeGenerator(url) {
    var body = document.body || document.documentElement;
    var iframe;
    var timerDestoryer = timerGenerator(function () {
      timerDestoryer = null;
      iframe = document.createElement('iframe');
      iframe.style.cssText = 'display:none;width:0px;height:0px;';
      iframe.src = url;
      body.appendChild(iframe);
    }, 100); // 防止销毁器执行太快导致 android 端收不到请求

    return function destroy() {
      if (timerDestoryer) {
        timerDestoryer();
      } else if (iframe) {
        body.removeChild(iframe);
        iframe = null;
      }
    };
  } // 客户端返回的状态码命名为 "result", 这里增加同等 "code"


  function fixResult(result) {
    if (isObject(result)) {
      if (isDefined(result.code)) {
        result.result = result.code;
      }

      if (isDefined(result.result)) {
        result.code = result.result;
      }
    }

    return result;
  } // 回调会执行多次，某些场景需要回调以队列形式执行


  var pending = false;
  var queue = [];

  var next = function next() {
    if (!pending && queue.length) {
      pending = true;
      queue.shift()(function () {
        pending = false;
        next();
      });
    }
  };

  var push = function push(fn) {
    return queue.push(fn) === 1 && next();
  };
  /*
   * 调用回调方法
   * @param {Number} callbackId - 回调方法ID
   * @param {Object} result - 回调结果
   * @param {Number} result.result 回调状态
   * @param {Object} result.data 回调数据
   */


  function execCallback(callback, result) {
    if (typeof callback === 'number') {
      callback = allCallbacks[callback];
    }

    if (isFunction(callback)) {
      result = fixResult(result);
      push(function (next) {
        // eslint-disable-line no-shadow
        setTimeout(function () {
          // 回调如果报错, pending 就一直为 true, 队列就永远不会消耗
          try {
            callback(result);
          } catch (ex) {
            console.error(ex); // eslint-disable-line no-console
          }

          next();
        }, 0); // 异步执行回调
      });
    }
  }
  /*
   * 在 App 中通过请求 url 来与客户端交互
   * @param {String} url - 请求地址
   */


  function invokeUrlInApp(url) {
    var iframeDestoryer = iframeGenerator(url); // 删除 iframe

    setTimeout(iframeDestoryer, 3000); // 延迟不能为0, 否则 Android 客户端有概率收不到
  }
  /*
   * 在浏览器中通过请求 url 来打开 App
   * @param {String} url - 请求地址
   */


  function invokeUrlInBrowser(url) {
    var baseUrl = 'https://qidian.gtimg.com/QDReader/'; // 呼起 App 基本路径

    var fallbackUrl = 'https://acts.qidian.com/2017/5813823/'; // 呼起 App 降级路径

    {
      var appUrl = url.replace(new RegExp("^".concat(schema, "://")), baseUrl); // 转换成能呼起 App 的路径

      {
        appUrl += appUrl.indexOf('?') > -1 ? '&' : '?';
        appUrl += "redirect=".concat(fallbackUrl);
      }
      location.href = appUrl;
    }
  }
  /**
   * 通过请求 url 来与客户端交互
   * @param {String} url - 请求地址
   * @param {Function} callback - 回调
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   *
   * @example <caption>调用"jsbridge://app:10/login"</caption>
   * location.href = 'jsbridge://app:10/login'
   *
   * @example <caption>调用"schema://do/some/action"</caption>
   * jssdk.invokeUrl('schema://do/some/action');
   */


  function invokeUrl(url) {
    if (isInBrowser) {
      invokeUrlInBrowser(url);
    } else {
      invokeUrlInApp(url);
    }
  }
  /**
   * 调用客户端
   * @param {String} module - 模块
   * @param {String} method - 方法
   * @param {Object} params - 参数
   * @param {Function} callback - 回调
   * @param {Object} callback.result - 回调参数
   * @param {Number} callback.result.code - 状态码
   * @param {Object} callback.result.data - 数据
   * @param {String} callback.result.msg - 消息
   *
   * @support iPad 3.7.3
   * @support iPhone 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   *
   * @example <caption>调用同"jssdk.device.getSystemVersion"</caption>
   * jssdk.invokeClient('device', 'getSystemVersion', {}, function (result) {
   *   alert(JSON.stringify(result));
   * });
   */


  function invokeClient(module, method, params, callback) {
    if (!module || !method) {
      return;
    }

    if (isFunction(params)) {
      callback = params;
      params = null;
    }

    var moduleMethod = "".concat(module, ".").concat(method);

    if (support(moduleMethod)) {
      if (isInBrowser) {
        invokeUrlInBrowser(urlGenerator(module, method, params));
      } else {
        var callbackId;

        if (isFunction(callback)) {
          callbackId = callbackIdGenerator();
          allCallbacks[callbackId] = callback;
        }

        invokeUrlInApp(urlGenerator(module, method, params, callbackId));
      }
    } else {
      execCallback(callback, {
        code: CODE_NOT_SUPPORT,
        msg: 'Not support!'
      });
    }
  }

  var eventCallbackNameGenerator = function eventCallbackNameGenerator(eventName) {
    return "evt-".concat(eventName);
  };
  /**
   * 注册事件
   * @param {String} name 事件名称
   * @param {Object} options 配置项
   * @param {Object} options.support - api支持版本配置
   * @param {String} options.support.android - android平台支持版本
   * @param {String} options.support.iOS - iOS平台支持版本(兼容iPhone平台和iPad平台)
   * @param {String} options.support.iPhone - iPhone平台支持版本
   * @param {String} options.support.iPad - iPad平台支持版本
   * @param {String} options.support.harmony - HarmonyOS平台支持版本
   * @param {String} options.support.browser - browser平台是否支持
   *
   * @example <caption>监听"pullUp"事件</caption>
   * jssdk.registerEvent('pullUp', {
   *   support: {
   *     android: '1.0.0',
   *     iOS: '1.0.0',
   *     iPhone: '1.0.0',
   *     iPad: '1.0.0',
   *     harmony: '1.0.0',
   *   },
   * });
   */


  function registerEvent(name, options) {
    if (isInBrowser || apiEvents[name]) {
      return;
    }

    var plat = platform;
    var supp = options.support;

    if (!supp[plat]) {
      // 没有指定平台，则尝试用通用的 iOS 和 android
      if (isIOS && supp.iOS) {
        plat = 'iOS';
      } else if (isAndroid && supp.android) {
        plat = 'android';
      } else if (isHarmony && supp.harmony) {
        plat = 'harmony';
      }
    }

    if (supp[plat]) {
      invokeUrlInApp(urlGenerator('event', 'add', {
        name: name
      }));
      var moduleMethod = "event.".concat(name); // 用于 supportVersion 判断

      apiSupports[moduleMethod] = supp[plat]; // 缓存事件名

      apiEvents[name] = true;
    }
  }
  /**
   * 添加事件监听
   * @param {String} eventName - 事件名称
   * @param {Function} handler - 处理方法
   */


  function addEventListener(eventName, handler) {
    if (isInBrowser) {
      return;
    }

    if (!apiEvents[eventName]) {
      return;
    }

    if (!isFunction(handler)) {
      return;
    }

    var moduleMethod = "event.".concat(eventName);

    if (support(moduleMethod)) {
      var callbackName = eventCallbackNameGenerator(eventName);

      if (!allCallbacks[callbackName]) {
        allCallbacks[callbackName] = [];
      }

      allCallbacks[callbackName].push(handler);
    }
  }
  /**
   * 移除事件监听
   * @param {String} eventName - 事件名称
   * @param {Function} handler - 处理方法
   */


  function removeEventListener(eventName, handler) {
    if (isInBrowser) {
      return;
    }

    var callbackName = eventCallbackNameGenerator(eventName);
    var handlers = allCallbacks[callbackName];

    if (!handlers) {
      return;
    }

    if (!handler) {
      delete allCallbacks[callbackName];
      return;
    }

    var i;

    for (i = handlers.length - 1; i >= 0; i--) {
      if (handler === handlers[i]) {
        handlers.splice(i, 1);
      }
    }
  }
  /*
   * 执行事件监听
   * @param {String} eventName - 事件名称
   * @param {Object} result - 事件结果
   * @param {Number} result.result 事件状态(0表示正常)
   * @param {Object} result.data 事件数据
   */


  function dispatchEvent(eventName, result) {
    if (isInBrowser) {
      return;
    }

    var callbackName = eventCallbackNameGenerator(eventName);
    var handlers = allCallbacks[callbackName];

    if (isArray(handlers)) {
      handlers.forEach(function (handler) {
        return handler(fixResult(result));
      });
    }
  } // SDK 根节点


  var jssdk = {
    __supports: apiSupports,
    __functions: apiFunctions,
    __events: apiEvents,
    __callbacks: allCallbacks,
    CODE_NOT_SUPPORT: CODE_NOT_SUPPORT,
    isAndroid: isAndroid,
    isIOS: isIOS,
    isInBrowser: isInBrowser,
    isHarmony: isHarmony,
    isSupport: isSupport,
    platform: platform,
    systemVersion: systemVersion,
    clientVersion: clientVersion,
    versionCode: versionCode,
    compare: compare,
    support: support,
    invokeUrl: invokeUrl,
    invokeClient: invokeClient,
    registerEvent: registerEvent,
    addEventListener: addEventListener,
    removeEventListener: removeEventListener
  };
  /**
   * 挂载 api 方法, 把指定 api 包装为固定的调用形式
   * @param {String} module - 模块名
   * @param {String} method - 方法名(注意: 以 "getXXX" 开头的方法名在生成调用客户端的url时会去掉 "get")
   * @param {Object} options - 配置
   * @param {Function} options.default - 默认调用方法(兼容所有平台)
   * @param {Function} options.android - android平台调用方法
   * @param {Function} options.iOS - iOS平台调用方法(兼容iPhone平台和iPad平台)
   * @param {Function} options.iPhone - iPhone平台调用方法
   * @param {Function} options.iPad - iPad平台调用方法
   * @param {Function} options.browser - browser平台调用方法
   * @param {Object} options.support - api支持版本配置
   * @param {String} options.support.android - android平台支持版本
   * @param {String} options.support.iOS - iOS平台支持版本(兼容iPhone平台和iPad平台)
   * @param {String} options.support.iPhone - iPhone平台支持版本
   * @param {String} options.support.iPad - iPad平台支持版本
   * @param {String} options.support.harmony - HarmonyOS平台支持版本
   * @param {Boolean} options.support.browser - browser平台是否支持
   *
   * @example <caption>挂载"jssdk.app.getBookInfo"方法</caption>
   * jssdk.mount('app', 'getBookInfo', {
   *   default: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   android: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   iOS: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   iPhone: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   iPad: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   harmony: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   browser: function (bookId, callback) {
   *     jssdk.invokeClient('app', 'getBookInfo', { bookId: bookId }, callback);
   *   },
   *   support: {
   *     android: '9.9.9',
   *     iOS: '9.9.9',
   *     iPhone: '9.9.9',
   *     iPad: '9.9.9',
   *     harmony: '9.9.9',
   *     browser: true,
   *   },
   * });
   *
   * @example <caption>调用"jssdk.app.getBookInfo"方法</caption>
   * jssdk.app.getBookInfo(123, function (data) {
   *   if (data.result === 0) {
   *     console.log(data.data);
   *   } else if (data.result === jssdk.CODE_NOT_SUPPORT) {
   *     console.warn('客户端不支持');
   *   }
   * });
   */

  function mount(module, method, options) {
    if (!jssdk[module]) {
      jssdk[module] = {};
    }

    if (jssdk[module][method]) {
      return;
    }

    var supp = options.support;
    var plat = platform;

    if (!supp[plat] && !isInBrowser && isIOS && supp.iOS) {
      plat = 'iOS';
    }

    if (!supp[plat] && !isInBrowser && isHarmony && supp.harmony) {
      plat = 'harmony';
    }

    var func = options[plat] || options["default"] || noop;
    var moduleMethod = "".concat(module, ".").concat(method);
    jssdk[module][method] = func; // 用于 supportVersion 判断

    if (supp[plat]) {
      apiSupports[moduleMethod] = supp[plat];
    } // 缓存方法


    apiFunctions[moduleMethod] = func;
  }

  jssdk.mount = mount;
  Object.defineProperty(jssdk, 'hibridge', {
    get: function get() {
      throw new Error('请在项目配置中启用 HiBridge');
    }
  });
  /**
   * @method addTimerTask
   * @description 新增定时任务
   * @param {Object} params 参数对象
   * @param {String} params.type 定时任务类型
   * @param {Number} params.min 定时任务开始时间戳(秒)
   * @param {Number} params.max 定时任务结束时间戳(秒)
   * @param {Number} params.step 定时任务间隔时间(秒)
   * @param {String} params.identity 定时任务指定类型下的唯一标识(可不传)
   * @param {Object} params.custom 定时任务自定义参数(可不传)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.addTimerTask 新增定时任务结果(true: 新增成功; false: 新增失败)
   *
   * @example <caption>新增"签到"定时任务</caption>
   * jssdk.app.addTimerTask({ type: 'sign', min: 1488528000, max: 1488614400, step: 3600 });
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   */

  var addTimerTask = {
    "default": function _default(params, callback) {
      invokeClient('app', 'addTimerTask', params, callback);
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method addToBookshelf
   * @description 加入书架
   * @param {Object} params 参数对象
   * @param {Number} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {String} params.author 作者名称
   * @param {String} params.siteType 站点类型(audio: 听书; comic: 漫画; newDialog: 对话小说)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.addToBookshelf 加入书架结果(true: 加入成功; false: 加入失败)
   *
   * @example <caption>将"斗罗大陆"加入到书架</caption>
   * jssdk.app.addToBookshelf({ bookId: 1115277, bookName: '斗罗大陆', author: '唐家三少' });
   *
   * @example <caption>将"超级仙医(听书)"加入到书架</caption>
   * jssdk.app.addToBookshelf({
   *   bookId: '3589688703294101',
   *   bookName: '超级仙医',
   *   author: '五志',
   *   siteType: 'audio'
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   *
   * @example <caption>将"航海王(漫画)"加入到书架</caption>
   * jssdk.app.addToBookshelf({
   *   bookId: '7928988703967102',
   *   bookName: '航海王',
   *   author: '尾田荣一郎',
   *   siteType: 'comic'
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   *
   * @example <caption>将"有图片的小说(对话小说)"加入到书架</caption>
   * jssdk.app.addToBookshelf({
   *   bookId: '14589368400031904',
   *   bookName: '有图片的小说',
   *   author: '小陆哈哈哈哈哈哈哈哈哈哈',
   *   siteType: 'newDialog'
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var addToBookshelf = {
    "default": function _default(params, callback) {
      invokeClient('app', 'addToBookshelf', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method buyChapter
   * @description 打开某书章节购买页
   * @param {Number} bookId 书籍ID
   * @param {Number} chapterId 章节ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"作品"第二十五章"的购买页</caption>
   * jssdk.app.buyChapter(1115277, 22525239);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var buyChapter = {
    "default": function _default(bookId, chapterId, callback) {
      invokeClient('app', 'buyChapter', {
        bookId: bookId,
        chapterId: chapterId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method buyVolume
   * @description 打开某书分册购买页（仅安卓）
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"分册购买页（仅安卓）</caption>
   * jssdk.app.buyVolume(1115277);
   *
   * @example <caption>打开"依然女生呀呀嘿"分册购买页（仅安卓）</caption>
   * jssdk.app.buyVolume(2450745);
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var buyVolume = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'buyVolume', {
        bookId: bookId
      }, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method addLocalNotification
   * @description 添加通知提醒
   * @param {Object} query 查询对象
   * @param {Array} query.notifys 设置本地提醒
   * @param {String} notifyId 提醒唯一ID
   * @param {String} timeInMills 提醒推送时间 毫秒
   * @param {String} title 提醒标题
   * @param {String} desc 提醒描述
   * @param {String} actionUrl 提醒跳转url
   * @param {Function} callback 回调方法
   * 
   * @example <caption>加入一条本地提醒</caption>
   * jssdk.app.addLocalNotification({
   *  notifys:[{
   *    notifyId:1111,
   *    timeInMills:1619345730000,
   *    title:"直播提醒",
   *    desc:"直播提醒描述",
   *    actionUrl:'QDReader://app/openLiveShow?query={"roomId":4,"sessionId":201}'
   * }]
   * }, function(data){
   *    alert(JSON.stringify(data));
   *  });
   * 
   *  @support iOS 5.9.110
   * @support android 7.9.110
   * @support harmony 1.0.0
   */

  var addLocalNotification = {
    "default": function _default(query, callback) {
      invokeClient('app', 'addLocalNotification', query, callback);
    },
    support: {
      "iOS": "5.9.110",
      "android": "7.9.110",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method cancelLocalNotification
   * @description 添加通知提醒
   * @param {Object} query 查询对象
   * @param {Array} query.notifyIds 本地提醒ID数组
   * @param {Function} callback 回调方法
   * 
   * @example <caption>取消本地提醒</caption>
   * jssdk.app.cancelLocalNotification({
   *  notifyIds:[1111,1112]
   * }, function(data){
   *  alert(JSON.stringify(data));
   * });
   * 
   *  @support iOS 5.9.110
   * @support android 7.9.110
   * @support harmony 1.0.0
   */

  var cancelLocalNotification = {
    "default": function _default(query, callback) {
      invokeClient('app', 'cancelLocalNotification', query, callback);
    },
    support: {
      "iOS": "5.9.110",
      "android": "7.9.110",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method queryLocalNotification
   * @description 查询通知提醒
   * @param {Object} query 查询对象
   * @param {Array} query.notifyId 查询的提醒ID
   * @param {Function} callback 回调方法
   * 
   * @example <caption>取消本地提醒</caption>
   * jssdk.app.queryLocalNotification({
   *   notifyId:1111
   * }, function(data){
   *  alert(JSON.stringify(data));
   * });
   * 
   *  @support iOS 5.9.110
   * @support android 7.9.110
   * @support harmony 1.0.0
   */

  var queryLocalNotification = {
    "default": function _default(query, callback) {
      invokeClient('app', 'queryLocalNotification', query, callback);
    },
    support: {
      "iOS": "5.9.110",
      "android": "7.9.110",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method addReadingProgress
   * @description 添加阅读进度
   * @param {Object} params 参数对象
   * @param {Number} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {Number} params.authorName 作者名
   * @param {Number} params.unreadNum 未读的章节数，-1 代表未读，0 代表读完
   * @param {String} params.timestamp 上报的时间戳
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.addReadingProgress 添加阅读进度结果(true: 加入成功; false: 加入失败)
   *
   *
   * @example <caption>上报"有图片的小说"的阅读进度</caption>
   * jssdk.app.addReadingProgress({
   *   bookId: '14589368400031904',
   *   bookName: '有图片的小说',
   *   authorName: '小陆哈哈哈哈哈哈哈哈哈哈',
   *   timestamp: '1596438603664',
   *   unreadNum: 23,
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   *
   * @example <caption>上报"有图片的小说"的阅读进度（未读）</caption>
   * jssdk.app.addReadingProgress({
   *   bookId: '14589368400031904',
   *   bookName: '有图片的小说',
   *   authorName: '小陆哈哈哈哈哈哈哈哈哈哈',
   *   timestamp: '1596438603664',
   *   unreadNum: -1,
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   *
   * @example <caption>上报"有图片的小说"的阅读进度（读完）</caption>
   * jssdk.app.addReadingProgress({
   *   bookId: '14589368400031904',
   *   bookName: '有图片的小说',
   *   authorName: '小陆哈哈哈哈哈哈哈哈哈哈',
   *   timestamp: '1596438603664',
   *   unreadNum: 0,
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.44
   * @support android 7.9.44
   * @support harmony 1.0.0
   */

  var addReadingProgress = {
    "default": function _default(params, callback) {
      invokeClient('app', 'addReadingProgress', params, callback);
    },
    support: {
      "iOS": "5.9.44",
      "android": "7.9.44",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getEncryptSign
   * @description 客户端加密，用于加密请求的参数
   * @param {Object} params 需要加密的对象(非对象则会用返回空对象的加密结果)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {String} callback.data.encryptSign 加密之后的字符串
   *
   * @example <caption>加密"{foo:1,bar:2}"</caption>
   * jssdk.app.getEncryptSign({foo:1,bar:2}, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 4.7.3
   * @support android 6.9.1
   * @support harmony 1.0.0
   */

  var getEncryptSign = {
    "default": function _default(params, callback) {
      if (_typeof(params) !== 'object' || params == null) {
        params = {};
      }

      invokeClient('app', 'getEncryptSign', {
        params: params
      }, callback);
    },
    support: {
      "iOS": "4.7.3",
      "android": "6.9.1",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getLatestBook
   * @description 获取当天最新阅读的一本书
   * @param {Boolean} isInBookshelf 是否只获取书架中的书(iOS端3.8.0此参数无效，只会取书架中的书)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.bookId 书籍ID
   * @param {String} callback.data.bookName 书籍名称
   * @param {String} callback.signedData 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signedData.bookId 签名后的书籍ID
   * @param {String} callback.signedData.bookName 签名后的书籍名称
   *
   * @example <caption>获取今天最新阅读的一本书</caption>
   * jssdk.app.getLatestBook(false, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>获取今天最新阅读的一本书(限书架作品)</caption>
   * jssdk.app.getLatestBook(true, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var getLatestBook = {
    "default": function _default(isInBookshelf, callback) {
      invokeClient('app', 'getLatestBook', {
        isInBookshelf: isInBookshelf
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /* eslint-disable import/prefer-default-export, prefer-template, max-len */

  function formatDate(date, format) {
    if (!format) {
      format = 'YYYY-MM-DD HH:mm:ss';
    }

    if (date === null) {
      return format;
    }

    if (!(date instanceof Date)) {
      date = new Date(date);
    } // 非正常的日期


    if (isNaN(date.getTime())) {
      return format;
    }

    var mappings = {
      'M+': date.getMonth() + 1,
      'D+': date.getDate(),
      'H+': date.getHours(),
      'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds()
    };

    if (/(Y+)/.test(format)) {
      format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    if (/(dd+)/.test(format)) {
      format = format.replace(RegExp.$1, '日一二三四五六七'.split('')[date.getDay()]);
    }

    Object.keys(mappings).forEach(function (key) {
      if (new RegExp('(' + key + ')').test(format)) {
        var matchedVal = RegExp.$1;
        var val = "".concat(mappings[key]);
        format = format.replace(matchedVal, matchedVal.length === 1 ? val : "00".concat(val).substr(val.length));
      }
    });
    return format;
  }
  /**
   * @method getReadingDuration
   * @description 获取当天阅读时长
   * @param {Object} params 参数对象
   * @param {Boolean} params.isTotal 是否获取所有书的阅读时长(false: 只获取书架中书的阅读时长; true: 获取所有书的阅读时长)
   * @param {String} params.date 日期(格式: YYYY-MM-DD)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.readingDuration 阅读时长(单位为秒)
   * @param {String} callback.signature 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signature.readingDuration 签名后的阅读时长
   *
   * @example <caption>获取今天阅读时长</caption>
   * jssdk.app.getReadingDuration({ isTotal: true }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>获取今天阅读时长(限书架作品)</caption>
   * jssdk.app.getReadingDuration({ isTotal: false }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */


  var getReadingDuration = {
    "default": function _default(params, callback) {
      if (typeof params === 'boolean') {
        params = {
          isTotal: params
        };
      } // 起点读书 android 7.0+ 接口需要 date


      {
        if (platform === 'android' && compare('7.0.0') <= 0 && !params.date) {
          params.date = formatDate(new Date(), 'YYYY-MM-DD');
        }
      }
      invokeClient('app', 'getReadingDuration', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getReadingPrefer
   * @description 获取用户当前设定男女频道
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.readingPrefer 男女频道(1: 男生频道; 2: 女生频道)
   * @param {String} callback.signedData 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signedData.readingPrefer 签名后的男女频道
   *
   * @example <caption>获取用户当前设定的男女频道</caption>
   * jssdk.app.getReadingPrefer(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var getReadingPrefer = {
    "default": function _default(callback) {
      invokeClient('app', 'getReadingPrefer', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  var minMillisecondsTimestamp = Math.pow(10, 10);

  function isMillisecondsTimestamp(timestamp) {
    return timestamp > minMillisecondsTimestamp;
  }
  /**
   * @method getRecommendBookListLastShare
   * @description 获取书单的最后一次分享记录
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.bookListId 书单ID
   * @param {Number} callback.data.timestamp 分享时间戳(单位为秒)
   * @param {Number} callback.data.channel 分享渠道(1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 5: 微博)
   * @param {String} callback.signedData 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signedData.bookListId 签名后的书单ID
   * @param {String} callback.signedData.timestamp 签名后的分享时间戳
   * @param {String} callback.signedData.channel 签名后的分享渠道
   *
   * @example <caption>获取书单的最后一次分享记录</caption>
   * jssdk.app.getRecommendBookListLastShare(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */


  var getRecommendBookListLastShare = {
    "default": function _default(callback) {
      invokeClient('app', 'getRecommendBookListLastShare', callback);
    },
    android: function android(callback) {
      invokeClient('app', 'getRecommendBookListLastShare', function (result) {
        // 2017-07-20新增：qd 的 android 返回的时间戳是毫秒，这里修复一下
        if (result.result === 0 && isMillisecondsTimestamp(result.data.timestamp)) {
          result.data.timestamp = Math.floor(result.data.timestamp / 1000);
        }

        callback(result);
      });
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method isInBookshelf
   * @description 判断某作品是否在书架中
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.inBookshelf 是否在书架中(false: 不在书架中; true: 在书架中)
   *
   * @example <caption>判断“斗罗大陆”是否在书架中</caption>
   * jssdk.app.isInBookshelf(1115277, function (data) {
   *   alert(JSON.stringify(data));
   * });
   * 
   * @example <caption>判断“有图片的小说”是否在书架中</caption>
   * jssdk.app.isInBookshelf('14589368400031904', function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.44
   * @support android 7.9.44
   * @support harmony 1.0.0
   */

  var isInBookshelf = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'isInBookshelf', {
        bookId: bookId
      }, callback);
    },
    support: {
      "iOS": "5.9.44",
      "android": "7.9.44",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getShareUserCode
   * @description 获取 shareUserCode
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态
   * @param {Object} callback.result.data 回调状态返回对象
   * @param {String} callback.result.data.shareUserCode 回调装填返回的 shareUserCode
   *
   * @example <caption>获取 shareUserCode</caption>
   * jssdk.app.getShareUserCode(function (result) {
   *   alert(JSON.stringify(result));
   *   if (result.code === 0) {
   *      // 获取成功，打印当前 shareUserCode
   *      console.log(result.data.shareUserCode)
   *   } else {
   *     console.log(result.data)
   *   }
   * });
   * @support iOS 5.9.72
   * @support android 7.9.72
   * @support harmony 1.0.0
   */

  var getShareUserCode = {
    "default": function _default(callback) {
      invokeClient('app', 'getShareUserCode', callback);
    },
    support: {
      "iOS": "5.9.72",
      "android": "7.9.72",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method isLatestVersion
   * @description 判断App是否是最新版
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.latestVersion 是否最新版本(false: 不是最新版; true: 是最新版)
   *
   * @example <caption>判断App是否是最新版</caption>
   * jssdk.app.isLatestVersion(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var isLatestVersion = {
    "default": function _default(callback) {
      invokeClient('app', 'isLatestVersion', callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /* eslint-disable max-len */

  /**
   * @method open
   * @description 打开新的页面
   * @param {String} url 页面地址(如果是一个网页, 则支持 viewmode 参数(0:页面全屏无Header; 1:页面全屏有透明不占位的Header; 2:有默认且占位的Header; 4:全屏，透明标题栏，无标题，按钮带背景显示（沉浸式导航）))
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"M站首页"</caption>
   * jssdk.app.open("https://m.qidian.com/");
   *
   * @example <caption>打开"M站阅历页"</caption>
   * jssdk.app.open("http://m.qidian.com/yueli?viewmode=1");
   *
   * @example <caption>打开"M站个人中心页"</caption>
   * jssdk.app.open("http://m.qidian.com/user?viewmode=0");
   *
   * @example <caption>打开"登录"</caption>
   * jssdk.app.openLogin(function (res) {
   *   console.log(JSON.stringify(res));
   * });
   *
   * @example <caption>打开"充值"</caption>
   * jssdk.app.openRecharge();
   *
   * @example <caption>新窗口打开一个外部站点 h5</caption>
   * jssdk.app.open("https://www.yuewen.com");
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   * @support browser
   */

  var open = {
    "default": function _default(url, viewmode, callback) {
      if (typeof viewmode === 'function') {
        callback = viewmode;
        viewmode = 2;
      }

      invokeClient('app', 'open', {
        url: url,
        viewmode: viewmode
      }, callback);
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openAuthor
   * @description 打开作者页
   * @param {Number} authorId 作者ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"唐家三少"主页</caption>
   * jssdk.app.openAuthor(4921);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openAuthor = {
    "default": function _default(authorId, callback) {
      invokeClient('app', 'openAuthor', {
        authorId: authorId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openBook
   * @description 打开某书阅读页
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"阅读页</caption>
   * jssdk.app.openBook(1115277);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openBook = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'openBook', {
        bookId: bookId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openBookComments
   * @description 打开某书评论页
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"评论页</caption>
   * jssdk.app.openBookComments(1115277);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openBookComments = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'openBookComments', {
        bookId: bookId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openBookLastPage
   * @description 打开某书末页
   * @param {Number} bookId 书籍ID
   * @param {String} bookName 书籍名称
   * @param {String} bookStatus 完本状态(完本/未完待续)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"末页</caption>
   * jssdk.app.openBookLastPage(1115277, '斗罗大陆', '完本');
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openBookLastPage = {
    "default": function _default(bookId, bookName, bookStatus, callback) {
      invokeClient('app', 'openBookLastPage', {
        bookId: bookId,
        bookName: bookName,
        bookStatus: bookStatus
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /* eslint-disable max-len */

  /**
   * @method openBookList
   * @description 通用书列表页(需要客户端的服务端开发支持)
   * @param {String} url 列表URL
   * @param {groupName} groupName 列表名称
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"同类作品"书列表页</caption>
   * jssdk.app.openBookList('/Atom.axd/Api/Recommend/GetRecommendDetail?groupId=129&channelId=9', '同类作品');
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBookList = {
    "default": function _default(url, groupName, callback) {
      invokeClient('app', 'openBookList', {
        url: url,
        groupName: groupName
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /* eslint-enable max-len */

  /**
   * @method openBookMonthTicket
   * @description 打开某书月票页
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.status 投月票状态(0: 未知, 1: 成功, -1: 取消)
   * @param {Array} callback.data.monthTicketList 投月票详情列表
   *
   * @example <caption>打开"三界清道夫"月票页</caption>
   * jssdk.app.openBookMonthTicket('2873067001254103', function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBookMonthTicket = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'openBookMonthTicket', {
        bookId: bookId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openBookRecommendTicket
   * @description 打开某书推荐票页
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"推荐票页</caption>
   * jssdk.app.openBookRecommendTicket(1115277);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBookRecommendTicket = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'openBookRecommendTicket', {
        bookId: bookId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openBookReward
   * @description 打开某书打赏页（仅安卓）
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"打赏页（仅安卓）</caption>
   * jssdk.app.openBookReward(1115277);
   *
   * @example <caption>测试环境：打开"依然女生呀呀嘿"打赏页（仅安卓）</caption>
   * jssdk.app.openBookReward(2450745);
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBookReward = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'openBookReward', {
        bookId: bookId
      }, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openBookshelf
   * @description 打开书架
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开书架</caption>
   * jssdk.app.openBookshelf();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openBookshelf = {
    "default": function _default(callback) {
      invokeClient('app', 'openBookshelf', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openBookStore
   * @description 打开书城
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开书城</caption>
   * jssdk.app.openBookStore();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBookStore = {
    "default": function _default(callback) {
      invokeClient('app', 'openBookStore', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openBoutiques
   * @description 打开精品专区
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开精品专区</caption>
   * jssdk.app.openBoutiques();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBoutiques = {
    "default": function _default(callback) {
      invokeClient('app', 'openBoutiques', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openBugFeedback
   * @description 打开问题反馈页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开问题反馈页</caption>
   * jssdk.app.openBugFeedback();
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openBugFeedback = {
    "default": function _default(callback) {
      invokeClient('app', 'openBugFeedback', callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openCategory
   * @description 打开某分类页
   * @param {Number} id
   * @param {String} name
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"仙侠"分类页</caption>
   * jssdk.app.openCategory(22, '仙侠');
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openCategory = {
    "default": function _default(id, name, callback) {
      invokeClient('app', 'openCategory', {
        id: id,
        name: name
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openCategorys
   * @description 打开分类列表页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开分类列表页</caption>
   * jssdk.app.openCategorys();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openCategorys = {
    "default": function _default(callback) {
      invokeClient('app', 'openCategorys', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openChapter
   * @description 打开某书某章节
   * @param {Number} bookId 书籍ID
   * @param {Number} chapterId 章节ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"作品"第二十五章"的阅读页</caption>
   * jssdk.app.openChapter(1115277, 22525239);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openChapter = {
    "default": function _default(bookId, chapterId, callback) {
      invokeClient('app', 'openChapter', {
        bookId: bookId,
        chapterId: chapterId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openDailyReading
   * @description 每日导读页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开每日导读页</caption>
   * jssdk.app.openDailyReading();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openDailyReading = {
    "default": function _default(callback) {
      invokeClient('app', 'openDailyReading', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openDiscussArea（仅安卓）
   * @description 打开即时讨论区
   * @param {Object} params 参数对象
   * @param {String} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {Number} params.hongbaoId 定位到的红包ID，可不传
   * @param {Number} params.openHongbaoId 要打开的红包ID，可不传
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"替嫁太子妃"即时讨论区（仅安卓）</caption>
   * jssdk.app.openDiscussArea({
   *   bookId: 3677961,
   *   bookName: '替嫁太子妃',
   *   hongbaoId: 689779,
   *   openHongbaoId: 689779,
   * });
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openDiscussArea = {
    "default": function _default(params, callback) {
      invokeClient('app', 'openDiscussArea', params, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openFeedback
   * @description 打开意见反馈页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开意见反馈页</caption>
   * jssdk.app.openFeedback();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openFeedback = {
    "default": function _default(callback) {
      invokeClient('app', 'openFeedback', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openFilter
   * @description 打开筛选页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开筛选页</caption>
   * jssdk.app.openFilter();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openFilter = {
    "default": function _default(callback) {
      invokeClient('app', 'openFilter', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openFind
   * @description 打开发现
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开发现</caption>
   * jssdk.app.openFind();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openFind = {
    "default": function _default(callback) {
      invokeClient('app', 'openFind', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openFree
   * @description 打开今日免费
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开今日免费</caption>
   * jssdk.app.openFree();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openFree = {
    "default": function _default(callback) {
      invokeClient('app', 'openFree', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method isLogin
   * @description 判断是否已登录
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.checkLogin 是否已登录(false: 未录; true: 已录)
   *
   * @example <caption>判断是否是登录状态</caption>
   * jssdk.app.isLogin(function (data) {
   *   console.log('登陆', JSON.stringify(data))
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.124
   * @support android 7.9.124
   * @support harmony 1.0.0
   */

  var isLogin = {
    "default": function _default(callback) {
      invokeClient('app', 'isLogin', callback);
    },
    support: {
      "iOS": "5.9.124",
      "android": "7.9.124",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openLogin
   * @description 打开登录 桥接新增参数 loginType: 1弹窗，2页面（仅iOS支持，安卓默认是页面）
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开登录</caption>
   * jssdk.app.openLogin(function (res) {
   *   console.log(JSON.stringify(res));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openLogin = {
    "default": function _default(callback) {
      invokeClient('app', 'openLogin', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openRank
   * @description 打开排行页
   * @param {Number} id 排行页左侧ID，可不传
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开排行页</caption>
   * jssdk.app.openRank();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openRank = {
    "default": function _default(params, callback) {
      var data = null;

      if (typeof params === 'function') {
        callback = params;
      } else if (typeof params === 'number') {
        data = {
          id: params
        };
      } else if (_typeof(params) === 'object') {
        data = params;
      }

      invokeClient('app', 'openRank', data, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openReceiveCoin
   * @description 打开领币页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开领币页</caption>
   * jssdk.app.openReceiveCoin();
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openReceiveCoin = {
    "default": function _default(callback) {
      invokeClient('app', 'openReceiveCoin', callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openRecharge
   * @description 打开充值页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开充值页</caption>
   * jssdk.app.openRecharge();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openRecharge = {
    "default": function _default(callback) {
      invokeClient('app', 'openRecharge', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openRechargeHistory
   * @description 打开充值记录页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开充值记录页</caption>
   * jssdk.app.openRechargeHistory();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openRechargeHistory = {
    "default": function _default(callback) {
      invokeClient('app', 'openRechargeHistory', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openRechargeWithChannel
   * @description 打开具体渠道充值页
   * @param {String} channel 充值渠道
   * @param {Number} totalFee 充值金额
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"支付宝"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_4_alipay_shortcut', 100); // 支付宝
   *
   * @example <caption>打开"移动手机短信"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_3_umpaypay_mobilesms', 100); // 移动手机短信
   *
   * @example <caption>打开"电信手机短信充值"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_3_huajianpay_sms9165', 100); // 电信手机短信充值
   *
   * @example <caption>打开"联通手机短信充值"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_3_huajianpay_sms5556', 100); // 联通手机短信充值
   *
   * @example <caption>打开"Paypal充值"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_7_payPal_USDCOST', 100); // Paypal充值
   *
   * @example <caption>打开"移动手机充值卡充值"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_8_shenzhouYD_USDCOST', 100); // 移动手机充值卡充值
   *
   * @example <caption>打开"电信手机充值卡充值"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_8_shenzhouDX_USDCOST', 100); // 电信手机充值卡充值
   *
   * @example <caption>打开"微信充值"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_2_WeChatPay_mobilesms', 100); // 微信充值
   *
   * @example <caption>打开"财付通"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_2_TenPay_mobilesms', 100); // 财付通
   *
   * @example <caption>打开"QQ钱包"充值记录页</caption>
   * jssdk.app.openRechargeWithChannel('g_2_WalletPay_mobilesms', 100); // QQ钱包
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openRechargeWithChannel = {
    "default": function _default(channel, totalFee, callback) {
      invokeClient('app', 'openRechargeWithChannel', {
        channel: channel,
        totalFee: totalFee
      }, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openRecommendBookList
   * @description 打开某书单页
   * @param {Number} id 书单ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开书单"2"</caption>
   * jssdk.app.openRecommendBookList(2);
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openRecommendBookList = {
    "default": function _default(id, callback) {
      invokeClient('app', 'openRecommendBookList', {
        id: id
      }, callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method openRecommendBookListComments
   * @description 打开某书单评论页
   * @param {Number} id 书单ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开书单"2"评论页</caption>
   * jssdk.app.openRecommendBookListComments(2);
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openRecommendBookListComments = {
    "default": function _default(id, callback) {
      invokeClient('app', 'openRecommendBookListComments', {
        id: id
      }, callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openRecommendBookListSquare
   * @description 打开书单广场
   * @param {Number} tab 定位标签(0:最新; 1:热门; 2:我的书单)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"最新"书单广场</caption>
   * jssdk.app.openRecommendBookListSquare(0);
   *
   * @example <caption>打开"热门"书单广场</caption>
   * jssdk.app.openRecommendBookListSquare(1);
   *
   * @example <caption>打开"我的书单"</caption>
   * jssdk.app.openRecommendBookListSquare(2);
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openRecommendBookListSquare = {
    "default": function _default(tab, callback) {
      invokeClient('app', 'openRecommendBookListSquare', {
        tab: tab
      }, callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openSendRedPacket
   * @description 打开发红包页（仅安卓）
   * @param {Number} bookId 书籍ID
   * @param {String} bookName 书籍名称
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"发红包页（仅安卓）</caption>
   * jssdk.app.openSendRedPacket(1115277, '斗罗大陆');
   *
   * @example <caption>测试环境：打开"依然女生呀呀嘿"发红包页（仅安卓）</caption>
   * jssdk.app.openSendRedPacket(2450745, '依然女生呀呀嘿');
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openSendRedPacket = {
    "default": function _default(bookId, bookName, callback) {
      invokeClient('app', 'openSendRedPacket', {
        bookId: bookId,
        bookName: bookName
      }, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openSetting
   * @description 打开设置页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开设置页</caption>
   * jssdk.app.openSetting();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openSetting = {
    "default": function _default(callback) {
      invokeClient('app', 'openSetting', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openSignIn
   * @description 打开签到页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开签到页</caption>
   * jssdk.app.openSignIn();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openSignIn = {
    "default": function _default(callback) {
      invokeClient('app', 'openSignIn', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openSubject
   * @description 类似精选页的通用界面(需要客户端的服务端开发支持)
   * @param {String} url 列表URL
   * @param {String} groupName 列表名称
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"开学季"书列表页</caption>
   * jssdk.app.openSubject('http://4g.if.qidian.com/Atom.axd/Api/VouchSpecial/Get?sid=320', '开学季');
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openSubject = {
    "default": function _default(url, groupName, callback) {
      invokeClient('app', 'openSubject', {
        url: url,
        groupName: groupName
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openSweep
   * @description 打开扫一扫
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开扫一扫</caption>
   * jssdk.app.openSweep();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openSweep = {
    "default": function _default(callback) {
      invokeClient('app', 'openSweep', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openTask
   * @description 打开任务页
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开任务页</caption>
   * jssdk.app.openTask();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var openTask = {
    "default": function _default(callback) {
      invokeClient('app', 'openTask', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openUserCenter
   * @description 打开个人中心
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开个人中心</caption>
   * jssdk.app.openUserCenter();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var openUserCenter = {
    "default": function _default(callback) {
      invokeClient('app', 'openUserCenter', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /**
   * @method queryTimerTask
   * @description 查询定时任务
   * @param {Object} params 参数对象
   * @param {String} params.type 定时任务类型
   * @param {String} params.identity 定时任务指定类型下的唯一标识(可不传)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Array} callback.data.tasks 定时任务列表(无定时任务为空数组)
   * @param {String} callback.data.tasks.identity 唯一标识
   * @param {Boolean} callback.data.tasks.isOpen 开启标识
   *
   * @example <caption>查询"签到"定时任务</caption>
   * jssdk.app.queryTimerTask({ type: 'sign' });
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   */

  var queryTimerTask = {
    "default": function _default(params, callback) {
      invokeClient('app', 'queryTimerTask', params, callback);
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method removeFromBookshelf
   * @description 从书架移除
   * @param {Object} params 参数对象
   * @param {Number} params.bookId 书籍ID
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.removeFromBookshelf 从书架移除的结果(true: 加入成功; false: 加入失败)
   *
   * @example <caption>将"有图片的小说(对话小说)"从书架中移除</caption>
   * jssdk.app.removeFromBookshelf({
   *   bookId: '14589368400031904',
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.44
   * @support android 7.9.44
   * @support harmony 1.0.0
   */

  var removeFromBookshelf = {
    "default": function _default(params, callback) {
      invokeClient('app', 'removeFromBookshelf', params, callback);
    },
    support: {
      "iOS": "5.9.44",
      "android": "7.9.44",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method removeTimerTask
   * @description 移除定时任务
   * @param {Object} params 参数对象
   * @param {String} params.type 定时任务类型
   * @param {String} params.identity 定时任务指定类型下的唯一标识(可不传)
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Array} callback.data 回调数据
   * @param {Boolean} callback.data.removeTimerTask 移除定时任务结果(true: 移除成功; false: 移除失败)
   *
   * @example <caption>移除"签到"定时任务</caption>
   * jssdk.app.removeTimerTask({ type: 'sign' }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   */

  var removeTimerTask = {
    "default": function _default(params, callback) {
      invokeClient('app', 'removeTimerTask', params, callback);
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method report
   * @description 数据上报(仅用于App内嵌页面，活动页勿用)
   * @param {Object} params 事件参数
   * @param {String} params.eventId 事件ID
   * @param {Number} params.eventType 事件类型(0:曝光; 1:点击)
   * @param {String} params.cbid 作品CBID
   * @param {String} params.groupId 事件分组ID
   * @param {String} params.cliUrl 链接地址
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>上报"内存不足-已解决"</caption>
   * jssdk.app.report({
   *   eventId: 'qdH5_HF_07',
   * });
   *
   * @example <caption>上报"版本过低-已解决"</caption>
   * jssdk.app.report({
   *   eventId: 'qdH5_HF_13',
   * });
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var report = {
    "default": function _default(params, callback) {
      // 向下兼容
      if (typeof params === 'string') {
        params = {
          eventId: params
        };
      }

      if (params && typeof callback === 'number') {
        params.eventType = callback;
        callback = arguments[2];
      }

      invokeClient('app', 'report', params, callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setNavigationRightButton
   * @description 自定义右上角按钮
   * @param {String} text 显示文本
   * @param {Function} callback 点击回调函数
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置右上角按钮为"分享斗罗大陆"</caption>
   * jssdk.app.setNavigationRightButton('分享', function () {
   *   share({
   *     title: '斗罗大陆',
   *     desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *     imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *     url: 'http://www.qidian.com/Book/1115277.aspx',
   *     channels: '1,2,3,5', // 依次显示分享渠道为：朋友圈，微信好友，QQ好友，微博
   *   });
   * });
   *
   * @support iOS 3.7.3-4.0.0
   * @support android 6.4.0-6.6.0
   * @support harmony 1.0.0
   */

  var setNavigationRightButton = {
    "default": function _default(text, callback) {
      if (support('ui.setHeaderRight')) {
        // 向上兼容
        invokeClient('ui', 'setHeaderRight', {
          text: text
        }, callback);
      } else {
        invokeClient('app', 'setNavigationRightButton', {
          text: text
        }, callback);
      }
    },
    support: {
      "iOS": "3.7.3-4.0.0",
      "android": "6.4.0-6.6.0",
      "harmony": "1.0.0"
    }
  };
  /* eslint-disable max-len */

  /**
   * @method share
   * @description 分享其他
   * @param {Object} params 分享配置
   * @param {Number} params.type 分享的类型：12、图片
   * @param {String} params.title 标题(最大45字节)
   * @param {String} params.desc 描述(最大60字节)
   * @param {String} params.titleViewText 面板标题
   * @param {Number} params.showTitleView 是否显示面板标题(0:不显示; 1:显示)
   * @param {String} params.helpUrl 右侧问号的帮助链接
   * @param {String} params.weiboText 新浪微博描述(最大60字节)
   * @param {String} params.imageUrl 图片地址(图片大小不能超过 128K，分享到Qzone时最小需要200 * 200)
   * @param {String} params.url 链接(长度不能超过120字节，超过的请转短链)
   * @param {String} params.channels 分享渠道(用","分割, 1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 4: QQ空间; 5: 微博)
   * @param {Boolean} params.hideUninstallChannel 是否隐藏未安装渠道
   * @param {Boolean} params.disableNativeAction 禁用原生动作(指给提示并且关闭页面, 设置为"true"了之后需要自行增加友好提示, 支持版本: iOS 4.1.0+, android 6.6.6+)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.status 分享状态(0:未知; 1:成功; -1:取消; -2:被应用拒绝)
   *
   * @example <caption>分享图片</caption>
   * jssdk.app.share({
   *   type: 12,
   *   imageUrl: 'https://qidian.qpic.cn/qidian_common/349573/60a4915f0239cbc0ade6686cfb19f04f/0',
   *   channels: '1,2,3,5', // 依次显示分享渠道为：朋友圈，QQ空间，微信好友,
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>分享"斗罗大陆"</caption>
   * jssdk.app.share({
   *   title: '斗罗大陆',
   *   desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *   imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   url: 'http://www.qidian.com/Book/1115277.aspx',
   *   channels: '1,2,3,5',
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>分享"斗罗大陆"(禁用原生动作)</caption>
   * jssdk.app.share({
   *   title: '斗罗大陆',
   *   desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *   imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   url: 'http://www.qidian.com/Book/1115277.aspx',
   *   channels: '1,2,3,5',
   *   disableNativeAction: true,
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   *
   * @example <caption>分享"斗罗大陆" ———— 海外分享</caption>
   * jssdk.app.share({
   *   title: '斗罗大陆',
   *   desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *   imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   url: 'http://www.qidian.com/Book/1115277.aspx'
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>分享"斗罗大陆"图片 ———— 海外图片分享</caption>
   * jssdk.app.share({
   *   title: '',
   *   desc: '',
   *   imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   url: '',
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  /* eslint-enable max-len */

  var share = {
    "default": function _default(params, callback) {
      invokeClient('app', 'share', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareBook
   * @description 分享书
   * @param {Object} params 分享配置
   * @param {Number} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {String} params.bookCover 封面图片
   * @param {String} params.author 书籍作者
   * @param {String} params.channels 分享渠道(用","分割, 1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 4: QQ空间; 5: 微博)
   * @param {Boolean} params.hideUninstallChannel 是否隐藏未安装渠道
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>分享"斗罗大陆"</caption>
   * jssdk.app.shareBook({
   *   bookId: 1115277,
   *   bookName: '斗罗大陆',
   *   bookCover: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   author: '唐家三少',
   *   channels: '2,3,5',
   *   hideUninstallChannel: true,
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var shareBook = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareBook', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareNote
   * @description 分享笔记（仅安卓）
   * @param {Object} params 分享配置
   * @param {Number} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {String} params.bookCover 封面图片
   * @param {String} params.content 内容
   * @param {String} params.channels 分享渠道(用","分割, 1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 4: QQ空间; 5: 微博)
   * @param {Boolean} params.hideUninstallChannel 是否隐藏未安装渠道
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>分享"斗罗大陆"笔记（仅安卓）</caption>
   * jssdk.app.shareNote({
   *   bookId: 1115277,
   *   bookName: '斗罗大陆',
   *   bookCover: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   content: '分享笔记',
   *   channels: '1,3,5',
   *   hideUninstallChannel: true,
   * });
   *
   *
   * @example <caption>测试环境：分享"依然女生呀呀嘿"笔记（仅安卓）</caption>
   * jssdk.app.shareNote({
   *  bookId: 2450745,
   *   bookName: '依然女生呀呀嘿',
   *   bookCover: 'https://bookcover.yuewen.com/qdbimg/349573/2450745/180',
   *   content: '分享笔记',
   *   channels: '1,3,5',
   *   hideUninstallChannel: true,
   * });
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var shareNote = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareNote', params, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareReward
   * @description 分享打赏（仅安卓）
   * @param {Object} params 分享配置
   * @param {Number} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {String} params.bookCover 封面图片
   * @param {Number} params.count 打赏数
   * @param {String} params.channels 分享渠道(用","分割, 1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 4: QQ空间; 5: 微博)
   * @param {Boolean} params.hideUninstallChannel 是否隐藏未安装渠道
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>分享"斗罗大陆"打赏（仅安卓）</caption>
   * jssdk.app.shareReward({
   *   bookId: 1115277,
   *   bookName: '斗罗大陆',
   *   bookCover: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   count: 100,
   *   channels: '1,2,3',
   *   hideUninstallChannel: true,
   * });
   *
   * @example <caption>测试环境：分享"依然女生呀呀嘿"打赏（仅安卓）</caption>
   * jssdk.app.shareReward({
   *   bookId: 2450745,
   *   bookName: '依然女生呀呀嘿',
   *   bookCover: 'https://bookcover.yuewen.com/qdbimg/349573/2450745/180',
   *   count: 100,
   *   channels: '1,2,3',
   *   hideUninstallChannel: true,
   * });
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var shareReward = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareReward', params, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareToChannel
   * @description 分享其他(指定渠道分享)
   * @param {Object} params 分享配置
   * @param {String} params.title 标题(最大45字节)
   * @param {String} params.desc 描述(最大60字节)
   * @param {String} params.imageUrl 图片地址(图片最小需要200 * 200，否则分享到Qzone时会被Qzone过滤掉)
   * @param {String} params.url 链接(长度不能超过120字节，超过的请转短链)
   * @param {Number} params.channel 分享渠道(1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 5: 微博)
   * @param {Boolean} params.disableNativeAction 禁用原生动作(指给提示并且关闭页面, 设置为"true"了之后需要自行增加友好提示)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.status 分享状态(0:未知; 1:成功; -1:取消; -2:被应用拒绝)
   *
   * @example <caption>分享"斗罗大陆"到朋友圈</caption>
   * jssdk.app.shareToChannel({
   *   title: '斗罗大陆',
   *   desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *   imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   url: 'http://www.qidian.com/Book/1115277.aspx',
   *   channel: 1, // 朋友圈
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>分享"斗罗大陆"给QQ好友</caption>
   * jssdk.app.shareToChannel({
   *   title: '斗罗大陆',
   *   desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *   imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   url: 'http://www.qidian.com/Book/1115277.aspx',
   *   channel: 3, // QQ好友
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 4.1.0
   * @support android 6.6.6
   * @support harmony 1.0.0
   */

  var shareToChannel = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareToChannel', params, callback);
    },
    support: {
      "iOS": "4.1.0",
      "android": "6.6.6",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareVote
   * @description 分享投票（仅安卓）
   * @param {Object} params 分享配置
   * @param {Number} params.bookId 书籍ID
   * @param {String} params.bookName 书籍名称
   * @param {String} params.bookCover 封面图片
   * @param {String} params.tickType 投票类型
   * @param {Number} params.tickCount 投票数
   * @param {String} params.channels 分享渠道(用","分割, 1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 4: QQ空间; 5: 微博)
   * @param {Boolean} params.hideUninstallChannel 是否隐藏未安装渠道
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>分享"斗罗大陆"投票（仅安卓）</caption>
   * jssdk.app.shareVote({
   *   bookId: 1115277,
   *   bookName: '斗罗大陆',
   *   bookCover: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *   tickType: 'type1',
   *   tickCount: 100,
   *   channels: '1,2,5',
   *   hideUninstallChannel: true,
   * });
   *
   * @example <caption>测试环境：分享"依然女生呀呀嘿"投票（仅安卓）</caption>
   * jssdk.app.shareVote({
   *   bookId: 2450745,
   *   bookName: '依然女生呀呀嘿',
   *   bookCover: 'https://bookcover.yuewen.com/qdbimg/349573/2450745/180',
   *   tickType: 'type1',
   *   tickCount: 100,
   *   channels: '1,2,5',
   *   hideUninstallChannel: true,
   * });
   *
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var shareVote = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareVote', params, callback);
    },
    support: {
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method showBook
   * @description 打开某书详情页
   * @param {Number} bookId 书籍ID
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开"斗罗大陆"详情页</caption>
   * jssdk.app.showBook(1115277);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   * @support browser
   */

  var showBook = {
    "default": function _default(bookId, callback) {
      invokeClient('app', 'showBook', {
        bookId: bookId
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0",
      "browser": true
    }
  };
  /* eslint-disable max-len */

  /**
   * @method showMore
   * @description 设置右上角菜单
   * @param {Object} params 配置
   * @param {Boolean} params.showShare 是否需要分享
   * @param {Object} params.shareItem 分享配置
   * @param {String} params.shareItem.title 分享标题(最大45字节)
   * @param {String} params.shareItem.desc 分享描述(最大60字节)
   * @param {String} params.shareItem.imageUrl 分享图片地址(图片大小不能超过 128K，分享到QQ空间时最小需要200 * 200)
   * @param {String} params.shareItem.url 分享链接(长度不能超过120字节，超过的请转短链)
   * @param {String} params.shareItem.channels 分享渠道(用","分割, 0:更多; 1:微信朋友圈; 2:微信好友; 3:QQ好友; 4:QQ空间; 5:新浪微博; 6:支付宝; 7:百度贴吧)
   * @param {Boolean} params.shareItem.hideUninstallChannel 是否隐藏未安装的渠道
   * @param {Boolean} params.shareItem.disableNativeAction 禁用原生动作(指给提示并且关闭页面, 设置为"true"了之后需要自行增加友好提示)
   * @param {Number} params.shareItem.type 分享类型(5:分享链接;12:分享纯图片)
   * @param {Number} params.shareItem.bitmapUrl 分享图片的地址，需要type为12
   * @param {String} params.shareItem.wxMiniProgramUserName 小程序名
   * @param {String} params.shareItem.wxMiniProgramPath 小程序路径
   * @param {String} params.shareItem.wxMiniProgramImageUrl 小程序图片地址
   * @param {Boolean} params.showComplain 是否显示投诉
   * @param {Boolean} params.showAddress 是否显示填写地址
   * @param {Array} params.otherItems 其他选项
   * @param {String} params.otherItems[].text 选项的文字
   * @param {String} params.otherItems[].icon 选项的图标
   * @param {String} params.otherItems[].url 点击的跳转动作
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置右上角菜单</caption>
   * jssdk.app.showMore({
   *   showShare: true,
   *   // 分享实体
   *   shareItem: {
   *     type: 5,
   *     channels: '1,2,3,5',
   *     title: '分享的标题(showMore)',
   *     desc: '分享的描述(showMore)',
   *     url: location.href,
   *     imageUrl: 'https://dwz.cn/DvbEjKkH',
   *     bitmapUrl: '',
   *     disableNativeAction: true, // 禁用客户端默认的回调，如果不设置，那么在Android下，无法执行回调函数。
   *   },
   *   showComplain: true,
   *   showAddress: true,
   *   otherItems: [{
   *     text: '起点M站',
   *     icon: 'https://qidian.qpic.cn/qidian_common/349573/c261eee92f0e2a9835a7a77437db163d/0',
   *     url: 'https://m.qidian.com/'
   *   }]
   * }, function(result) {
   *   console.log(result)
   * });
   *
   * @support iOS 5.5.0
   * @support android 7.5.0
   * @support harmony 1.0.0
   */

  var showMore = {
    "default": function _default(params, callback) {
      invokeClient('app', 'showMore', params, callback);
    },
    support: {
      "iOS": "5.5.0",
      "android": "7.5.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method signIn
   * @description 签到
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.signIn 签到结果(true: 签到成功; false: 签到失败)
   *
   * @example <caption>签到</caption>
   * jssdk.app.signIn(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var signIn = {
    "default": function _default(callback) {
      invokeClient('app', 'signIn', callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method unsetNavigationRightButton
   * @description 移除右上角自定义按钮
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>移除右上角自定义按钮</caption>
   * jssdk.app.unsetNavigationRightButton();
   *
   * @support iOS 3.7.3-4.0.0
   * @support android 6.4.0-6.6.0
   * @support harmony 1.0.0
   */

  var unsetNavigationRightButton = {
    "default": function _default(callback) {
      if (support('ui.unsetHeaderRight')) {
        // 向上兼容
        invokeClient('ui', 'unsetHeaderRight', callback);
      } else {
        invokeClient('app', 'unsetNavigationRightButton', callback);
      }
    },
    support: {
      "iOS": "3.7.3-4.0.0",
      "android": "6.4.0-6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method upgrade
   * @description App检查更新
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>App检查更新</caption>
   * jssdk.app.upgrade();
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var upgrade = {
    "default": function _default(callback) {
      invokeClient('app', 'upgrade', callback);
    },
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method checkThemeMode
   * @description 检查是否是深色模式
   * @param {Function} callback 回调方法
   * @param {Object} callback.data 回调返回数据
   * @param {Number} callback.data.code 回调返回获取成功与否
   * @param {Object} callback.data.data 回调返回的数据信息
   * @param {Object} callback.data.data.result 回调返回的主题信息 0: 浅色模式, 1: 深色模式
   *
   * @example <caption>检查是否是深色模式</caption>
   * jssdk.app.checkThemeMode(function (data) {
   *   alert(JSON.stringify(data));
   *   if (data.code === 0) {
   *      // 获取成功，打印当前主题色
   *      console.log(data.data.result)
   *   } else {
   *      // result.message  返回错误信息文案
   *   }
   * });
   * @support iOS 5.9.25
   * @support android 7.9.24
   * @support harmony 1.0.0
   */

  var checkThemeMode = {
    "default": function _default(callback) {
      invokeClient('app', 'checkThemeMode', callback);
    },
    support: {
      "iOS": "5.9.25",
      "android": "7.9.24",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method cashBuy
   * @description 现金购买物品
   * @param {Object} query 查询参数
   * @param {String} query.ProductId 产品id
   * @param {Number} query.ProductType 产品类型
   * @param {String} query.OrderNo 业务订单id
   * @param {Number} query.Amount 待支付金额，单位：分
   * @param {Number} query.YwAmount 起点币，单位：点
   * @param {String} query.MoreUrl 支付说明更多的url地址
   * @param {String} query.PayDesc 支付说明文案
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调返回状态数据
   * @param {Object} callback.orderId 支付成功后的支付订单号
   *
   * @example <caption>购买商品</caption>
   * jssdk.app.cashPay({ ProductId: "597809423955591168", ProductType: 80001, OrderNo: "ZC619472142735572992", Amount: 9990, YwAmount: 9990, MoreUrl: "", PayDesc: "成功后请按提示填写相关邮寄信息，失败后支付金额将原路返还\n·订单超时未支付将自动关闭订单"}, function (result) {
   *   alert(JSON.stringify(result));
   * });
   * @support iOS 5.9.124
   * @support android 7.9.124
   * @support harmony 1.0.0
   */

  var cashPay = {
    "default": function _default(params, callback) {
      invokeClient('app', 'cashPay', params, callback);
    },
    support: {
      "iOS": "5.9.124",
      "android": "7.9.124",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openInteractionDialog
   * @description 投月票给某本书
   * @param {Object} params 参数对象
   * @param {String} params.bookId 书ID
   * @param {String} params.bookName 书名
   * @param {Number} params.chapterId 定位章节ID
   * @param {Number} params.isPublish 出版书 0：否 1：是
   * @param {Number} params.hideYp 是否隐藏月票tab 0：否 1：是
   * @param {Number} params.pageIndex tab 1：推荐票 2：月票 3：打赏
   * @param {Number} params.midPageId 中间页ID 可不传
   * @param {String} params.activityId 活动ID 可不传
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态
   *
   * @example <caption>投月票给某本书</caption>
   * jssdk.app.openInteractionDialog({
   *     bookId: '4576',
   *     bookName: '测试书本',
   *     chapterId: 0,
   *     isPublish: 0,
   *     hideYp: 0,
   *     pageIndex: 2,
   *     midPageId: 0,
   *     activityId: '20118271'
   *   }, function (e) {
   *     alert(JSON.stringify(e))
   *})
   * @support iOS 5.9.146
   * @support android 7.9.146
   * @support harmony 1.0.0
   */

  var openInteractionDialog = {
    "default": function _default(params, callback) {
      invokeClient('app', 'openInteractionDialog', params, callback);
    },
    support: {
      "iOS": "5.9.146",
      "android": "7.9.146",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method showBatchPurchase
   * @description 批量订阅一本书（半弹层）
   * @param {Object} params 参数对象
   * @param {String} params.bookId 书ID
   * @param {String} params.activityId 活动ID 可不传
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态
   *
   * @example <caption>批量订阅哼哼唧唧投66测试书（半弹层）</caption>
   * jssdk.app.showBatchPurchase({
   *      bookId: '4576',
   *      activityId: '20118271'
   *    }, function (e) {
   *      alert(JSON.stringify(e))
   *    })
   * @support iOS 5.9.146
   * @support android 7.9.146
   * @support harmony 1.0.0
   *
   * @example <caption>批量订阅琅琊榜线上书（半弹层）</caption>
   * jssdk.app.showBatchPurchase({
   *      bookId: '86464',
   *      activityId: '1',
   *    }, function (e) {
   *      alert(JSON.stringify(e));
   *    });
   * @support iOS 5.9.146
   * @support android 7.9.146
   * @support harmony 1.0.0;
   *
   */

  var showBatchPurchase = {
    "default": function _default(params, callback) {
      invokeClient('app', 'showBatchPurchase', params, callback);
    },
    support: {
      "iOS": "5.9.146",
      "android": "7.9.146",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method queryReceiveCalendarActivity
   * @description 查询活动是否设置日历
   * @param {Object} params 参数对象
   * @param {String} params.activityId 活动 ID 必传
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态 status 0:失败 1:成功
   *
   * @example <caption>查询活动是否设置日历</caption>
   * jssdk.app.queryReceiveCalendarActivity({
   *     activityId: '858195176',
   *   }, function (e) {
   *     alert(JSON.stringify(e))
   *})
   * @support iOS 5.9.206
   * @support android 7.9.206
   * @support harmony 1.0.0
   */

  var queryReceiveCalendarActivity = {
    "default": function _default(params, callback) {
      invokeClient('app', 'queryReceiveCalendarActivity', params, callback);
    },
    support: {
      "iOS": "5.9.206",
      "android": "7.9.206",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method saveCalendarActivity
   * @description 设置活动日历提醒
   * @param {Object} params 参数对象
   * @param {String} params.activityId 活动 ID 必传
   * @param {String} params.startTime 开始时间(秒)
   * @param {String} params.endTime 结束时间(秒)
   * @param {String} params.alarmRelativeOffset 距离活动多久提醒(秒; 负数-开始前提醒, 正数-开始后提醒)
   * @param {String} params.notes 备注
   * @param {String} params.title 标题
   * @param {String} params.url 链接
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态 status 0:失败 1:成功
   *
   * @example <caption>设置活动日历提醒</caption>
   * jssdk.app.saveCalendarActivity({
   *     activityId: '858195176',
   *     startTime: '',
   *     endTime: '',
   *     alarmRelativeOffset: 1,
   *     notes: 0,
   *     title: 'title',
   *     url: '',
   *   }, function (e) {
   *     alert(JSON.stringify(e))
   *})
   * @support iOS 5.9.206
   * @support android 7.9.206
   * @support harmony 1.0.0
   */

  var saveCalendarActivity = {
    "default": function _default(params, callback) {
      invokeClient('app', 'saveCalendarActivity', params, callback);
    },
    support: {
      "iOS": "5.9.206",
      "android": "7.9.206",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method downloadImage
   * @description 下载图片到相册
   * @param {Object} params 参数对象
   * @param {String} params.url 图片地址
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态 status 0:下载失败 1:下载成功，已保存至相册
   *
   * @example <caption>下载图片到相册</caption>
   * jssdk.app.downloadImage({
   *     url: 'https://imgservices-1252317822.image.myqcloud.com/image/042620220224835/5de887ca.png',
   *   }, function (e) {
   *     alert(JSON.stringify(e))
   *})
   * @support iOS 5.9.124
   * @support android 7.9.268
   * @support harmony 1.0.0
   */

  var downloadImage = {
    "default": function _default(params, callback) {
      invokeClient('app', 'downloadImage', params, callback);
    },
    support: {
      "iOS": "5.9.124",
      "android": "7.9.268",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getPayChannel
   * @description 获取当前充值渠道号（只支持微信和支付宝）
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调返回数据
   * @param {Number} callback.result.channelId 回调返回渠道号 微信 2 支付宝 3
   *
   * @example <caption>获取当前充值渠道号（只支持微信和支付宝）</caption>
   * jssdk.app.getPayChannel(function (e) {
   *     alert(JSON.stringify(e))
   * })
   * @support iOS 5.9.124
   * @support android 7.9.124
   */

  var getPayChannel = {
    "default": function _default(callback) {
      invokeClient('app', 'getPayChannel', callback);
    },
    support: {
      "iOS": "5.9.124",
      "android": "7.9.124"
    }
  };
  /**
   * @method gotoPay
   * @description 微信、支付宝的支付
   * @param {Object} params 参数对象
   * @param {Number} params.channelId 非必传 微信 2 支付宝 3
   * @param {Number} params.money 必传 金钱数（单位：分）例如：1元 传 100 分
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调返回状态数据
   * @param {Number} callback.result.code 回调 成功 0 失败 1
   *
   * @example <caption>微信、支付宝的支付</caption>
   * jssdk.app.gotoPay({
   *     channelId: 2,
   *     money:100
   *   }, function (e) {
   *     alert(JSON.stringify(e))
   *})
   * @support iOS 5.9.124
   * @support android 7.9.124
   * @support harmony 1.0.0
   */

  var gotoPay = {
    "default": function _default(params, callback) {
      invokeClient('app', 'gotoPay', params, callback);
    },
    support: {
      "iOS": "5.9.124",
      "android": "7.9.124",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method launchMiniProgram
   * @description 打开起点小程序
   * @param {Object} params 参数对象
   * @param {String} params.userName 小程序原始id
   * @param {String} params.path 小程序页面路径
   * @param {String} params.env 小程序环境  trial: 体验版, dev:开发版 release: 正式版(默认)，开发版需在开发工具中生成二维码，提前用手机扫码打开后才能在端内拉起
   *
   * @example <caption>打开体验版起点小程序</caption>
   * jssdk.app.launchMiniProgram({
   *   userName: 'gh_cbd5578eba26',
   *   path: '/pages/index',
   *   env:'trial'
   * });
   *
   * @example <caption>打开开发版起点小程序</caption>
   * jssdk.app.launchMiniProgram({
   *   userName: 'gh_cbd5578eba26',
   *   path: '/pages/index',
   *   env:'dev'
   * });
   *
   *
   * @example <caption>打开线上版起点小程序</caption>
   * jssdk.app.launchMiniProgram({
   *   userName: 'gh_cbd5578eba26',
   *   path: '/pages/index',
   * });
   *
   *
   * @example <caption>打开起点小程序webview跳转h5页</caption>
   * jssdk.app.launchMiniProgram({
   *   userName: 'gh_cbd5578eba26',
   *   path: '/pages/webview?url=https://mp.weixin.qq.com/s/nzNiUj9D6tLq0PSH8TJTNw',
   * });
   *
   * @example <caption>打开起点小程序webview跳转起点活动页</caption>
   * jssdk.app.launchMiniProgram({
   *   userName: 'gh_cbd5578eba26',
   *   path: '/pages/webview?url=https://ataru.qidian.com/noah/875274939',
   * });
   *
   * @example <caption>打开起点小程序webview跳转起点活动页(沉浸式导航)</caption>
   * jssdk.app.launchMiniProgram({
   *   userName: 'gh_cbd5578eba26',
   *   path: '/pages/webview?url=https://oaataru.qidian.com/noah/875275381?_viewmode=1',
   * });
   *
   * @support iOS 5.9.226
   * @support android 7.9.226
   * @support harmony 1.0.0
   */

  var launchMiniProgram = {
    "default": function _default(params, callback) {
      invokeClient('app', 'launchMiniProgram', params, callback);
    },
    support: {
      "iOS": "5.9.226",
      "android": "7.9.226",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openTabWebViewWithScrollNavi
   * @description 设置 App 顶部 Tab
   * @param {Object} params 参数对象
   * @param {Number} params.initialIndex 初始定位到第几个tab 默认 0
   * @param {Array} params.titles 多 tab 标题
   * @param {Array} params.urls 多 tab 网页
   * @param {Number} params.height 滑动距离(滑动一定距离时，导航栏主题由begin状态切换到end状态)
   * @param {Number} params.beginIsDark 起始位置是白色或者黑色模式  0 或者 1
   * @param {String} params.color 结束位置选中文字颜色
   * @param {String} params.unselectColor 结束位置未选中文字颜色
   * @param {String} params.indicatorColor 结束位置选中指示器颜色
   * @param {String} params.bgColor 结束位置背景色
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态
   *
   * @example <caption>设置 App 顶部 Tab</caption>
   * jssdk.app.openTabWebViewWithScrollNavi({
   *   initialIndex: 0,
   *   titles: ['会员卡', '追书包'],
   *   urls: ['https://brave.if.qidian.com/h5/chaseBookCard', 'QDReader://shaman.if.qidian.com/statics/member/index.html'],
   *   height: 200,
   *   beginIsDark: 0,
   *   color: '#191919',
   *   unselectColor: '#4C4C4C',
   *   indicatorColor: '#E5353E',
   *   bgColor: '#FFFFFF'
   * }, function (e) {
   *   alert(JSON.stringify(e))
   * })
   * @support iOS 5.9.226
   * @support android 7.9.226
   * @support harmony 1.0.0
   */

  var openTabWebViewWithScrollNavi = {
    "default": function _default(params, callback) {
      invokeClient('app', 'openTabWebViewWithScrollNavi', params, callback);
    },
    support: {
      "iOS": "5.9.226",
      "android": "7.9.226",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setDisallowInterceptTouchRects
   * @description 设置网页某个区域不受原生 APP 手势滑动的影响，只响应网页自己默认的事件
   * @param {Object} params 参数对象
   * @param {Array} params.rects
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态
   *
   * @example <caption>设置网页某个区域不受原生 APP 手势滑动的影响，只响应网页自己默认的事件</caption>
   * jssdk.app.setDisallowInterceptTouchRects({
   *   rects: [
   *     {
   *       left: 50,
   *       right: 50,
   *       top: 200,
   *       bottom: 500
   *     },
   *     {
   *       left: 50,
   *       right: 50,
   *       top: 500,
   *       bottom: 200
   *     }
   *   ]
   * }, function(data) {
   *    alert(JSON.stringify(data));
   * });
   * @support iOS 5.9.124
   * @support android 7.9.124
   * @support harmony 1.0.0
   */

  var setDisallowInterceptTouchRects = {
    "default": function _default(params, callback) {
      invokeClient('app', 'setDisallowInterceptTouchRects', params, callback);
    },
    support: {
      "iOS": "5.9.124",
      "android": "7.9.124",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method addBigEmoji
   * @description 添加点娘大表情
   * @param {Object} params 参数对象
   * @param {String} params.packageId 表情 Id
   * @param {Function} callback 回调函数
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.status 0：失败 1：成功
   *
   * @example <caption>添加点娘大表情（测试环境）</caption>
   * jssdk.app.addBigEmoji({
   *    packageId:'665606233373343744'
   * });
   *
   * @example <caption>添加点娘大表情（线上）</caption>
   * jssdk.app.addBigEmoji({
   *    packageId:'343498129028481024'
   * });
   *
   * @support iOS 5.0.0
   * @support android 6.0.0
   * @support harmony 1.0.0
   */

  var addBigEmoji = {
    "default": function _default(params, callback) {
      invokeClient('app', 'addBigEmoji', params, callback);
    },
    support: {
      "iOS": "5.0.0",
      "android": "6.0.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method addedEmojiIds
   * @description 检查已添加的点娘大表情
   * @param {Function} callback 回调方法
   * @param {Object} callback.data 回调返回数据对象
   * @param {Number} callback.result 回调返回的数据状态
   * @param {Number} callback.code 回调状态 0成功，1失败
   * @param {Array} callback.data.packageIds 返回的表情 Id 数组 ['1','2','3']
   *
   * @example <caption>检查已添加的点娘大表情</caption>
   * jssdk.app.addedEmojiIds(function (data) {
   *   alert(JSON.stringify(data));
   * });
   * @support iOS 5.0.0
   * @support android 6.0.0
   * @support harmony 1.0.0
   */

  var addedEmojiIds = {
    "default": function _default(callback) {
      invokeClient('app', 'addedEmojiIds', callback);
    },
    support: {
      "iOS": "5.0.0",
      "android": "6.0.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method isTryMode
   * @description 判断是否是试用模式 此模式不会读取用户的信息
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Boolean} callback.data.isTryMode 是否是试用模式 (false: 否; true: 是)
   *
   * @example <caption>判断是否是试用模式</caption>
   * jssdk.app.isTryMode(function (data) {
   *   console.log('是否试用模式', JSON.stringify(data))
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.234
   * @support android 7.9.234
   * @support harmony 1.0.0
   */

  var isTryMode = {
    "default": function _default(callback) {
      invokeClient('app', 'isTryMode', callback);
    },
    support: {
      "iOS": "5.9.234",
      "android": "7.9.234",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareTo
   * @description 不唤起弹层直接分享
   * @param {Object} params 分享配置
   * @param {String} params.title 标题
   * @param {String} params.description 描述
   * @param {String} params.url 链接
   * @param {Number} params.channel 分享频道（1是微信朋友圈，2是微信好友，3是QQ好友，5是新浪微博）
   * @param {String} params.imageUrl 分享图
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>分享"斗罗大陆"</caption>
   * jssdk.app.shareTo({
   *    title:'标题',
   *    description:'描述',
   *    url:'https://m.qidian.com',
   *    channel:2,
   *    imageUrl:'https://facepic.qidian.com/qd_face/349573/218/100'
   * });
   *
   * @support iOS 5.9.234
   * @support android 7.9.234
   * @support harmony 1.0.0
   */

  var shareTo = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareTo', params, callback);
    },
    support: {
      "iOS": "5.9.234",
      "android": "7.9.234",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method startVipPay
   * @description 开通包月(安卓用)
   * @param {Object} params 参数
   * @param {Number} params.amount 开通档位金额
   * @param {Number} params.ywAmount 开通档位点币
   * @param {Number} params.channels 支持的支付渠道 1:支付宝 2:微信
   * @param {Number} params.gearId 档位id
   * @param {Number} params.productId 计费商品 id
   * @param {Number} params.productType 计费商品类型
   * @param {Number} params.days 天数
   * @param {Object} params.couponDetail 优惠券详情
   * @param {Number} params.couponDetail.CouponId 优惠券Id
   * @param {Number} params.couponDetail.CouponType 优惠券类型 101满赠 102满减
   * @param {String} params.couponDetail.CouponName 优惠券名字
   * @param {Number} params.couponDetail.ReduceAmount 优惠金额
   * @param {Number} params.couponDetail.MinAmount 优惠门槛金额
   * @param {Number} params.couponDetail.CouponStatus 优惠状态 1 可用 0 不可用
   * @param {Number} params.couponDetail.Recommend 推荐 1 推荐 0 不是推荐
   * @param {Number} params.couponDetail.EndTime 优惠券结束时间 时间戳
   * @param {Number} params.couponDetail.StartTime 优惠券开始时间 时间戳
   * @param {String} params.couponDetail.HighlightTip 不可用原因
   * @param {Object} params.couponDetail.NativeInfo 设备信息
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>开通包月(安卓用)</caption>
   * jssdk.app.startVipPay({
   *    amount:10,
   *    ywAmount:1,
   *    channels:1,
   *    gearId:1,
   *    productId:1,
   *    productType:1,
   *    days:1,
   *    couponDetail:{
   *       CouponId:"id",
   *       CouponType:101,  // 101满赠 102满减
   *       CouponName:"优惠券名字",
   *       ReduceAmount:"",
   *       MinAmount:"",
   *       CouponStatus:0, // 1 可用 0 不可用
   *       Recommend:0, // 0 不是推荐 1 推荐
   *       EndTime:"2023-12-12:12:00:00",
   *       StartTime:"2023-12-12:12:00:00",
   *       HighlightTip:"不可用原因",
   *       NativeInfo:{} // 设备信息不变，此处不列举
   *    }
   * });
   *
   * @support iOS 5.9.234
   * @support android 7.9.234
   * @support harmony 1.0.0
   */

  var startVipPay = {
    "default": function _default(params, callback) {
      invokeClient('app', 'startVipPay', params, callback);
    },
    support: {
      "iOS": "5.9.234",
      "android": "7.9.234",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method startVipPaySingleChannel
   * @description 开通包月(安卓用，和 startVipPay 区别在于直接在 h5 里选支付渠道，原来是在端内选支付渠道)
   * @param {Object} params 参数
   * @param {Number} params.amount 开通档位金额
   * @param {Number} params.ywAmount 开通档位点币
   * @param {Number} params.channels 支持的支付渠道 1:支付宝 2:微信
   * @param {Number} params.gearId 档位id
   * @param {Number} params.productId 计费商品 id
   * @param {Number} params.productType 计费商品类型
   * @param {Number} params.days 天数
   * @param {Object} params.couponDetail 优惠券详情
   * @param {Number} params.couponDetail.CouponId 优惠券Id
   * @param {Number} params.couponDetail.CouponType 优惠券类型 101满赠 102满减
   * @param {String} params.couponDetail.CouponName 优惠券名字
   * @param {Number} params.couponDetail.ReduceAmount 优惠金额
   * @param {Number} params.couponDetail.MinAmount 优惠门槛金额
   * @param {Number} params.couponDetail.CouponStatus 优惠状态 1 可用 0 不可用
   * @param {Number} params.couponDetail.Recommend 推荐 1 推荐 0 不是推荐
   * @param {Number} params.couponDetail.EndTime 优惠券结束时间 时间戳
   * @param {Number} params.couponDetail.StartTime 优惠券开始时间 时间戳
   * @param {String} params.couponDetail.HighlightTip 不可用原因
   * @param {Object} params.couponDetail.NativeInfo 设备信息
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>开通包月(安卓用)</caption>
   * jssdk.app.startVipPaySingleChannel({
   *    amount:10,
   *    ywAmount:1,
   *    channels:1,
   *    gearId:1,
   *    productId:1,
   *    productType:1,
   *    days:1,
   *    couponDetail:{
   *       CouponId:"id",
   *       CouponType:101,  // 101满赠 102满减
   *       CouponName:"优惠券名字",
   *       ReduceAmount:"",
   *       MinAmount:"",
   *       CouponStatus:0, // 1 可用 0 不可用
   *       Recommend:0, // 0 不是推荐 1 推荐
   *       EndTime:"2023-12-12:12:00:00",
   *       StartTime:"2023-12-12:12:00:00",
   *       HighlightTip:"不可用原因",
   *       NativeInfo:{} // 设备信息不变，此处不列举
   *    }
   * });
   *
   * @support iOS 5.9.298
   * @support android 7.9.298
   * @support harmony 1.0.0
   */

  var startVipPaySingleChannel = {
    "default": function _default(params, callback) {
      invokeClient('app', 'startVipPaySingleChannel', params, callback);
    },
    support: {
      "iOS": "5.9.298",
      "android": "7.9.298",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openIAP
   * @description 开通包月(iOS用)
   * @param {Object} params 参数
   * @param {Number} params.productId 计费商品 id
   * @param {Number} params.productType 计费商品类型 0-普通商品 1-包月商品
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>开通包月（iOS 用）</caption>
   * jssdk.app.openIAP({
   *    productId:1,
   *    productType:1,
   * });
   *
   * @support iOS 5.9.234
   * @support android 7.9.234
   * @support harmony 1.0.0
   */

  var openIAP = {
    "default": function _default(params, callback) {
      invokeClient('app', 'openIAP', params, callback);
    },
    support: {
      "iOS": "5.9.234",
      "android": "7.9.234",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method checkAppEnv
   * @description 检查当前 App 所在环境
   * @param {Function} callback 回调方法
   * @param {Object} callback.data 回调返回数据
   * @param {Number} callback.data.code 回调返回获取成功与否
   * @param {Object} callback.data.data 回调返回的数据信息
   * @param {String} callback.data.data.Env 回调返回的环境信息 appEnv:"release（线上）/debug（测试）/cepingtuan（测评团）"
   *
   * @example <caption>检查当前 App 所在环境</caption>
   * jssdk.app.checkAppEnv(function (data) {
   *   alert(JSON.stringify(data));
   * });
   * @support iOS 5.9.250
   * @support android 7.9.250
   * @support harmony 1.0.0
   */

  var checkAppEnv = {
    "default": function _default(callback) {
      invokeClient('app', 'checkAppEnv', callback);
    },
    support: {
      "iOS": "5.9.250",
      "android": "7.9.250",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method enableVisitorLoginState
   * @description 判断是否处于游客模式（仅ios支持，安卓不支持）
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态(0-关闭, 1-开启)
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>判断是否处于游客模式（仅ios支持，安卓不支持）</caption>
   * jssdk.app.enableVisitorLoginState(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.234
   * @support android 7.9.234
   * @support harmony 1.0.0
   */

  var enableVisitorLoginState = {
    "default": function _default(callback) {
      invokeClient('app', 'enableVisitorLoginState', callback);
    },
    support: {
      "iOS": "5.9.234",
      "android": "7.9.234",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method inAppEvaluationNeedShow
   * @description iOS专用，获取用户评价状态
   * @param {Function} callback 回调函数
   * @param {Number} callback.result true/flase
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>iOS专用，7天内是否展示评价</caption>
   * jssdk.app.inAppEvaluationNeedShow(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.250
   * @support android 7.9.250
   * @support harmony 1.0.0
   */

  var inAppEvaluationNeedShow = {
    "default": function _default(callback) {
      invokeClient('app', 'inAppEvaluationNeedShow', callback);
    },
    support: {
      "iOS": "5.9.250",
      "android": "7.9.250",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method inAppEvaluationState
   * @description iOS专用，获取用户评价状态
   * @param {Function} callback 回调函数
   * @param {Number} callback.result true/false
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>iOS专用，获取用户评价状态</caption>
   * jssdk.app.inAppEvaluationState(function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.250
   * @support android 7.9.250
   * @support harmony 1.0.0
   */

  var inAppEvaluationState = {
    "default": function _default(callback) {
      invokeClient('app', 'inAppEvaluationState', callback);
    },
    support: {
      "iOS": "5.9.250",
      "android": "7.9.250",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openInAppEvaluate
   * @description iOS专用，唤起评价弹窗
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>iOS专用，唤起评价弹窗</caption>
   * jssdk.app.openInAppEvaluate();
   *
   * @support iOS 5.9.256
   * @support android 7.9.256
   * @support harmony 1.0.0
   */

  var openInAppEvaluate = {
    "default": function _default(callback) {
      invokeClient('app', 'openInAppEvaluate', callback);
    },
    support: {
      "iOS": "5.9.256",
      "android": "7.9.256",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method reportFingerprint
   * @description 上报设备指纹
   * @param {Object} params 事件参数
   * @param {String} params.fingerprint_values
   * @param {Number} params.fingerprint_hash
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>上报设备指纹</caption>
   * jssdk.app.reportFingerprint({
   *   fingerprint_values: 'xxxx',
   *   fingerprint_hash:'xxxx'
   * });
   *
   * @support iOS 5.9.206
   * @support android 7.9.206
   * @support harmony 1.0.0
   */

  var reportFingerprint = {
    "default": function _default(callback) {
      invokeClient('app', 'reportFingerprint', callback);
    },
    support: {
      "iOS": "5.9.206",
      "android": "7.9.206",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareToDouyin
   * @description 调用抖音并打开资源发布
   * @param {Object} params 参数
   * @param {String} params.videoUrl 视频地址
   * @param {String} params.shareTitle 标题
   * @param {String} params.shareId 分享 Id
   * @param {String} params.clientKey 获取授权的code
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>调用抖音并打开资源发布</caption>
   * jssdk.app.shareToDouyin({
   *   videoUrl: "videoUrl",
   *   shareTitle: "标题",
   *   shareId: "123",
   *   clientKey:"xxx"
   * });
   *
   * @support iOS 5.9.280
   * @support android 7.9.280
   * @support harmony 1.0.0
   */

  var shareToDouyin = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareToDouyin', params, callback);
    },
    support: {
      "iOS": "5.9.280",
      "android": "7.9.280",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getDyAuthCode
   * @description 获取抖音授权绑定起点账号
   * @param {Object} params 参数
   * @param {String} params.scope 抖音发布作用域：video.data,video.list,item.comment(测试环境不加)
   * @param {String} params.clientKey 获取授权的code
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>获取抖音授权绑定起点账号</caption>
   * jssdk.app.getDyAuthCode({
   *   scope: "video.data,video.list,item.comment",
   *   clientKey:"xxx"
   * });
   *
   * @support iOS 5.9.280
   * @support android 7.9.280
   * @support harmony 1.0.0
   */

  var getDyAuthCode = {
    "default": function _default(params, callback) {
      invokeClient('app', 'getDyAuthCode', params, callback);
    },
    support: {
      "iOS": "5.9.280",
      "android": "7.9.280",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method startVipCouponSelectedDialog
   * @description 安卓端调起会员优惠券选择弹层
   * @param {Object} params 参数对象
   * @param {Number} params.userSelectedCouponId 优惠券id
   * @param {Number} params.originalAmount 原价
   * @param {Function} callback 回调函数
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>安卓端调起会员优惠券选择弹层</caption>
   * jssdk.app.startVipCouponSelectedDialog({
   *    userSelectedCouponId:1,
   *    originalAmount:10
   * });
   *
   * @support iOS 5.0.0
   * @support android 7.9.288
   * @support harmony 1.0.0
   */

  var startVipCouponSelectedDialog = {
    "default": function _default(params, callback) {
      invokeClient('app', 'startVipCouponSelectedDialog', params, callback);
    },
    support: {
      "iOS": "5.0.0",
      "android": "7.9.288",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method userInfo
   * @description 获取用户信息
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>获取用户信息</caption>
   * jssdk.app.userInfo(function (data) {
   *     console.log('用户信息:',JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.294
   * @support android 7.9.294
   * @support harmony 1.0.0
   */

  var userInfo = {
    "default": function _default(callback) {
      invokeClient('app', 'userInfo', callback);
    },
    support: {
      "iOS": "5.9.294",
      "android": "7.9.294",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method voteMonthTicket
   * @description 直接投月票给某本书，并展示票根
   * @param {Object} params 参数对象
   * @param {String} params.bookId 书ID
   * @param {Number} params.count 月票数量
   * @param {String} params.sourceId 章节id，帖子下面投票传帖子Id
   * @param {Number} params.sourceType 1-中间页（彩蛋章），2-番外章， 3-大额打赏
   * @param {String} params.activityId 活动id
   * @param {Number} params.voteType 0-正常投月票，1-催更投月票
   * @param {Number} params.pushUpdateType 0-章末等其他场景催更，1-票根帖子下催更
   * @param {Function} callback 回调方法
   * @param {Object} callback.result 回调状态
   * @param {Number} callback.result.status 0-投月票成功，1-投月票失败
   * @param {String} callback.result.msg 错误信息
   *
   * @example <caption>直接投月票给某本书，并展示票根(线上琅琊榜)</caption>
   * jssdk.app.voteMonthTicket({
   *   bookId: '86464',
   *   count: 2,
   *   sourceId: '4156156',
   *   sourceType: 0,
   *   activityId: '123',
   *   voteType: 0,
   *   pushUpdateType: 0,
   * }, (res) => {
   *   alert(JSON.stringify(res));
   * })
   * @support iOS 5.9.258
   * @support android 7.9.258
   * @support harmony 1.0.0
   */

  var voteMonthTicket = {
    "default": function _default(params, callback) {
      invokeClient('app', 'voteMonthTicket', params, callback);
    },
    support: {
      "iOS": "5.9.258",
      "android": "7.9.258",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method uploadLog
   * @description 客户端上传日志，无请求参数
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Number} callback.result.code 状态码
   * @param {Object} callback.result.data 回调状态返回对象
   * @param {String} callback.result.data.logUrl 日志 cos 存储的 url
   *
   * @example <caption>客户端上传日志</caption>
   * jssdk.app.uploadLog();
   *
   * @support iOS 5.9.260
   * @support android 7.9.260
   * @support harmony 1.0.0
   */

  var uploadLog = {
    "default": function _default(callback) {
      invokeClient('app', 'uploadLog', callback);
    },
    support: {
      "iOS": "5.9.260",
      "android": "7.9.260",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method consumeCashPay
   * @description 调用安卓现金支付（支付宝和微信），iOS 不支持
   * @param {Object} params 参数对象
   * @param {String} params.appType 应用类型
   * @param {String} params.itemId 商品ID
   * @param {String} params.orderNo 订单编号
   * @param {Number} params.amount 金额
   * @param {Number} params.ywAmount 阅文点币金额
   * @param {Number} params.productType 产品类型 默认为 0
   * @param {String} params.productId 产品ID 此参数 app 端在包月时必传，其他情况需传有内容的字符串，不需要时传'0'
   * @param {Number} params.chargeType 充值类型 1 是冲且扣 0 是虚拟币充值
   * @param {String} params.fromad 来源 例如：`${encodeURI('2023070303|shouye')}` | 需要 encode
   * @param {String} params.creatTime 订单创建时间
   * @param {String} params.timeOut 订单过期时间
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>调用安卓现金支付（支付宝和微信）</caption>
   * jssdk.app.consumeCashPay({
   *     appType:"330",
   *     itemId: "994000402",
   *     orderNo: "0",
   *     amount: 1,
   *     ywAmount: 1,
   *     productType: 0,
   *     productId:'',
   *     chargeType: 1,
   *     fromad: "XXX", // `${encodeURI('2023070303|shouye')}`
   *     creatTime: "@timestamp", //订单创建时间
   *     timeOut:"@timestamp()", //订单过期时间
   * });
   *
   * @support iOS 5.9.296
   * @support android 7.9.296
   * @support harmony 1.0.0
   */

  var consumeCashPay = {
    "default": function _default(params, callback) {
      invokeClient('app', 'consumeCashPay', params, callback);
    },
    support: {
      "iOS": "5.9.296",
      "android": "7.9.296",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openPayInCash
   * @description 调用 ApplePay 苹果支付 （安卓勿用）
   * @param {Object} params 参数对象
   * @param {String} params.productId 商品ID（只支持默认档位：1,6,12,50,98,298）参数例子：m.qidian.QDReaderAppStore.100dian
   * @param {String} params.orderNo 订单编号
   * @param {Number} params.ywAmount 阅文点币金额
   * @param {Number} params.chargeType 充值类型 1 是冲且扣 0 是虚拟币充值
   * @param {Function} callback 回调函数
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>调用 ApplePay 苹果支付 （安卓勿用）</caption>
   * jssdk.app.openPayInCash({
   *     productId: "m.qidian.QDReaderAppStore.100dian",
   *     orderNo: "1",
   *     ywAmount: 100,
   *     chargeType: 0,
   * });
   *
   * @support iOS 5.9.174
   */

  var openPayInCash = {
    "default": function _default(params, callback) {
      invokeClient('app', 'openPayInCash', params, callback);
    },
    support: {
      "iOS": "5.9.174"
    }
  };
  /**
   * @method specialDevice
   * @description 获取安卓特殊设备（例如模拟器等）
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态 0：正常设备 App 1：其他设备的 App
   *
   * @example <caption>获取安卓特殊设备（例如模拟器等）</caption>
   * jssdk.app.specialDevice(function (data) {
   *     console.log('回调:',JSON.stringify(data));
   * });
   *
   * @support iOS 5.0.0
   * @support android 7.9.282
   * @support harmony 1.0.0
   */

  var specialDevice = {
    "default": function _default(callback) {
      invokeClient('app', 'specialDevice', callback);
    },
    support: {
      "iOS": "5.0.0",
      "android": "7.9.282",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openPushPermission
   * @description 打开app通知权限
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>打开app通知权限</caption>
   *
   * jssdk.app.openPushPermission(function (res) {
   *   console.log(JSON.stringify(res));
   *   alert(JSON.stringify(res));
   * });
   *
   * @support iOS 5.9.312
   * @support android 7.9.312
   * @support harmony 1.0.0
   */

  var openPushPermission = {
    "default": function _default(callback) {
      invokeClient('app', 'openPushPermission', callback);
    },
    support: {
      "iOS": "5.9.312",
      "android": "7.9.312",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method queryPushPermission
   * @description 查询app通知权限名
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>查询app通知权限名</caption>
   *
   * jssdk.app.queryPushPermission(function (res) {
   *   console.log(JSON.stringify(res));
   *   alert(JSON.stringify(res));
   * });
   *
   * @support iOS 5.9.312
   * @support android 7.9.312
   * @support harmony 1.0.0
   */

  var queryPushPermission = {
    "default": function _default(callback) {
      invokeClient('app', 'queryPushPermission', callback);
    },
    support: {
      "iOS": "5.9.312",
      "android": "7.9.312",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method networkEnvironment
   * @description 获取当前设备网络环境
   * @param {Function} callback 回调方法
   * @param {Number} callback.data 返回当前网络环境 NotReachable（不可用） WWAN（运营商） WIFI
   *
   * @example <caption>获取当前设备网络环境</caption>
   * jssdk.app.networkEnvironment(function (res) {
   *   console.log(JSON.stringify(res));
   *   alert(JSON.stringify(res));
   * });
   *
   * @support iOS 5.9.356
   * @support android 7.9.356
   * @support harmony 1.0.0
   */

  var networkEnvironment = {
    "default": function _default(callback) {
      invokeClient('app', 'networkEnvironment', callback);
    },
    support: {
      "iOS": "5.9.356",
      "android": "7.9.356",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method queryAudioPlayStatus
   * @description 查询听书状态
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 0：暂停 1：播放 2：未在听书
   *
   * @example <caption>查询听书状态</caption>
   *
   * jssdk.app.queryAudioPlayStatus(function (res) {
   *   console.log(JSON.stringify(res));
   *   alert(JSON.stringify(res));
   * });
   *
   * @support iOS 5.9.340
   * @support android 7.9.340
   * @support harmony 1.0.0
   */

  var queryAudioPlayStatus = {
    "default": function _default(callback) {
      invokeClient('app', 'queryAudioPlayStatus', callback);
    },
    support: {
      "iOS": "5.9.340",
      "android": "7.9.340",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method operateAudioPlayStatus
   * @description 更改听书状态
   * @param {Object} params 参数对象
   * @param {Number} params.play 0：暂停 1：播放
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 更改后的回调结果
   *
   * @example <caption>暂停听书</caption>
   *
   * jssdk.app.operateAudioPlayStatus({ play: 0 }, function (res) {
   *   console.log(JSON.stringify(res));
   *   alert(JSON.stringify(res));
   * });
   *
   * @example <caption>播放听书</caption>
   * jssdk.app.operateAudioPlayStatus({ play: 1 }, function (res) {
   *   console.log(JSON.stringify(res));
   *   alert(JSON.stringify(res));
   * });
   *
   * @support iOS 5.9.340
   * @support android 7.9.340
   * @support harmony 1.0.0
   */

  var operateAudioPlayStatus = {
    "default": function _default(params, callback) {
      invokeClient('app', 'operateAudioPlayStatus', params, callback);
    },
    support: {
      "iOS": "5.9.340",
      "android": "7.9.340",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method showRewardVideo
   * @description 打开视频广告
   * @param {Object} params 参数对象
   * @param {Number} params.appId aooId 通常 ios 和安卓不一样
   * @param {String} params.posId posId 通常 ios 和安卓不一样
   * @param {Number} callback 回调函数
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.status  1：广告已经显示  2：已经完成激励时长 3：广告被点击  4：视频播放结束 5：广告被关闭  -1：报错
   *
   * @example <caption>打开视频广告</caption>
   *     var posId = jssdk.isIOS ? "4090766867324479" : "5060464897920401";
   *     var appId = jssdk.isIOS ? 1108248575 : 1108323910;
   * jssdk.app.showRewardVideo({
   *    appId:appId || 1108248575,
   *    posId:posId || "4090766867324479"
   * }, function(data) {
   *    console.log(JSON.stringify(data));
   *    alert(JSON.stringify(data));
   * });;
   *
   * @support iOS 5.0.0
   * @support android 7.0.0
   * @support harmony 1.0.0
   */

  var showRewardVideo = {
    "default": function _default(params, callback) {
      invokeClient('app', 'showRewardVideo', params, callback);
    },
    support: {
      "iOS": "5.0.0",
      "android": "7.0.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method preloadRewardVideo
   * @description 预加载视频广告
   * @param {Object} params 参数对象
   * @param {Number} params.appId aooId 通常 ios 和安卓不一样
   * @param {String} params.posId posId 通常 ios 和安卓不一样
   * @param {Number} callback 回调函数
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>预加载视频广告</caption>
   *     var posId = jssdk.isIOS ? "4090766867324479" : "5060464897920401";
   *     var appId = jssdk.isIOS ? 1108248575 : 1108323910;
   * jssdk.app.preloadRewardVideo({
   *    appId:appId || 1108248575,
   *    posId:posId || "4090766867324479"
   * }, function(data) {
   *   console.log(JSON.stringify(data));
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.5.0
   * @support android 7.5.0
   * @support harmony 1.0.0
   */

  var preloadRewardVideo = {
    "default": function _default(params, callback) {
      invokeClient('app', 'preloadRewardVideo', params, callback);
    },
    support: {
      "iOS": "5.5.0",
      "android": "7.5.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method putStorageValue
   * @description 设置 jssdk 缓存
   * @param {Object} params 参数对象
   * @param {String} params.key key 值
   * @param {String} params.value value 值 传空代表清除
    *
   * @example <caption>设置缓存测试</caption>
   *     jssdk.app.putStorageValue({
   *       key: 'test',
   *       value: 'testValue'
   *     })
   * @support iOS 5.0.0
   * @support android 7.0.0
   * @support harmony 1.0.0
   */

  var putStorageValue = {
    "default": function _default(params) {
      invokeClient('app', 'putStorageValue', params);
    },
    support: {
      "iOS": "5.0.0",
      "android": "7.0.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method storageValue
   * @description 获取 jssdk 缓存 key 对应的值
   * @param {Object} params 参数对象
   * @param {String} params.key key 值
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Object} callback.data.value 回调数据返回的 value 值
   *
   * @example <caption>获取缓存测试</caption>
   *    jssdk.app.storageValue({
   *       key: 'test',
   *    }, function (data) {
   *       alert(JSON.stringify(data));
   *    });
   * @support iOS 5.0.0
   * @support android 7.0.0
   * @support harmony 1.0.0
   */

  var storageValue = {
    "default": function _default(params, callback) {
      invokeClient('app', 'storageValue', params, callback);
    },
    support: {
      "iOS": "5.0.0",
      "android": "7.0.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method addActivityPost
   * @description 前往发帖页（标记从活动来源）
   * @param {Object} params 参数对象
   * @param {String} params.circleId 书友圈、点点圈 ID
   * @param {String} params.topicName 话题名
   * @param {String} params.topicId 话题 ID
   * @param {String} params.actId 活动 ID
   * @param {String} params.actExtend 透传扩展字段
   * @param {String} params.titleHint 自定义标题
   * @param {String} params.contentHint 自定义文案
   * @param {Array} params.links 链接组
   * @param {String} params.links.linkId 链接 ID
   * @param {String} params.links.linkName 链接名
   * @param {String} params.links.linkUrl 链接地址
   *
   * @example <caption>前往发帖页（标记从活动来源，测试环境）</caption>
   * jssdk.app.addActivityPost({
   *    circleId:'23479016302058404',
   *    topicName:'测试话题',
   *    topicId:'785171600910647296',
   *    actId:'112221231231',
   *    actExtend:'扩展字段',
   *    titleHint:'自定义标题',
   *    contentHint:'自定义文案',
   *    links:[
   *      {
   *        linkId:'1',
   *        linkName:'链接名',
   *        linkUrl:'https://m.qidian.com/'
   *      },
   *      {
   *        linkId:'2',
   *        linkName:'链接名2',
   *        linkUrl:'https://my.qidian.com/'
   *      }
   *    ]
   * });
   *
   *
   * @support iOS 5.9.378
   * @support android 7.9.378
   * @support harmony 1.0.0
   */

  var addActivityPost = {
    "default": function _default(params) {
      invokeClient('app', 'addActivityPost', params);
    },
    support: {
      "iOS": "5.9.378",
      "android": "7.9.378",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method shareActivityComment
   * @description 以图片形式分享帖子
   * @param {Object} params 配置
   * @param {Object} params.shareItem 分享内容
   * @param {Number} params.shareItem.type 分享类型 112 新版UGC 场景（章段评，段落，活动评论）（109 新版分享组件分享本书（庆余年需求新增） 110 新版组件分享海报  111 新版分享组件分享本章 ）
   * @param {String} params.shareItem.title 分享标题
   * @param {String} params.shareItem.desc 分享内容
   * @param {String} params.shareItem.url 分享链接
   * @param {String} params.shareItem.imageUrl 分享图片链接
   * @param {Boolean} params.shareItem.disabledNativeAction 是否禁用客户端的默认回调，如果不设置，那么在安卓下，无法执行回调函数
   * @param {String} params.shareItem.wxMiniProgramUserName 小程序名
   * @param {String} params.shareItem.wxMiniProgramPath 小程序路径
   * @param {String} params.shareItem.wxMiniProgramImageUrl 小程序图片地址
   * @param {String} params.shareItem.weiboText 微博文案
   * @param {String} params.shareItem.shareActivityTitle 分享半弹层里的标题
   * @param {String} params.shareItem.shareActivityIcon 分享半弹层里的图标
   * @param {String} params.shareItem.shareActivityUrl 分享半弹层里的链接
   * @param {Array} params.types 枚举类型
   * @param {Number} params.showSaveImg 是否显示保存图片按钮
   * @param {Number} params.showCopyLink 是否显示复制链接
   * @param {Object} params.card 卡片信息
   * @param {String} params.card.userHeadImg 用户头像
   * @param {String} params.card.userName 用户名
   * @param {String} params.card.commentTime 评论时间
   * @param {String} params.card.contentTitle 评论标题
   * @param {String} params.card.contentText 评论内容
   * @param {String} params.card.contentImg 评论图片内容
   * @param {String} params.card.bookId 书籍ID
   * @param {String} params.card.bookName 书籍名称
   * @param {String} params.card.author 作者
   * @param {String} params.card.qRCode 二维码链接
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>以图片形式分享帖子</caption>
   *    jssdk.app.shareActivityComment({
   *       shareItem: {
   *         type: 112,
   *         channels: '1,2,3,5',
   *         title: '测试标题',
   *         desc: '测试内容',
   *         url: location.href,
   *         imageUrl: 'https://imgservices-1252317822.image.myqcloud.com/coco/s09182023/8c2fa349.nhnsxz.png',
   *         disabledNativeAction: true,
   *         wxMiniProgramUserName: 'gh_cbd5578eba26',
   *         wxMiniProgramPath: 'pages/index/index',
   *         wxMiniProgramImageUrl: 'https://imgservices-1252317822.image.myqcloud.com/coco/s09182023/8c2fa349.nhnsxz.png',
   *         weiboText: '微博文案',
   *         shareActivityTitle: '分享活动标题', // 分享半弹层里的标题
   *         shareActivityIcon: 'https://imgservices-1252317822.image.myqcloud.com/coco/s09182023/8c2fa349.nhnsxz.png',
   *         shareActivityUrl: 'https://m.qidian.com/',
   *       },
   *       types: [1], // 枚举类型
   *       showSaveImg: 1, // 是否显示保存图片按钮
   *       showCopyLink: 1, // 显示复制链接
   *       card: {
   *         userHeadImg: 'https://ccportrait.yuewen.com/apimg/349573/p_3617882004664701/100', // 用户头像
   *         userName: '测试用户名', // 用户名
   *         commentTime: '2024-11-13 12:00', // 评论时间
   *         contentTitle: '测试标题', // 评论标题
   *         contentText: '一开始，顾朝夕以为自己得到的是日常任务系统。一心想着刷奖励。\n' +
   *           '“让开。”\n' +
   *           '”好咧。”\n' +
   *           '【完成任务，获得一百元，好感度+1】\n' +
   *           '“需要帮忙吗？”\n' +
   *           '“走开，不需要。”\n' +
   *           '“好的。”\n' +
   *           '【完成任务，获得三百元，好感度+5】', // 评论文字内容
   *         contentImg: 'https://imgservices-1252317822.image.myqcloud.com/coco/s11182022/5d3bf687.jpwmp4.jpg', // 评论图片内容
   *         bookId: '2450745',
   *         bookName: '依然女生呀呀嘿',
   *         author: '小红鞋走天下',
   *         qRCode: 'https://oaataru.qidian.com/noah/120226087/detail?_viewmode=0&isMock=1&bookId=4576', // 二维码链接
   *       },
   *     }, function (result) {
   *       console.log(result);
   *     });
   *
   * @support iOS 5.9.378
   * @support android 7.9.378
   * @support harmony 1.0.0
   */

  var shareActivityComment = {
    "default": function _default(params, callback) {
      invokeClient('app', 'shareActivityComment', params, callback);
    },
    support: {
      "iOS": "5.9.378",
      "android": "7.9.378",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method displayRewardVideo
   * @description 打开视频广告 会依次按照顺序返回所有事件，和 showRewardVideo 的区别是 showRewardVideo 只会返回一个状态 （可用于互动式广告）
   * @param {Object} params 参数对象
   * @param {Number} params.appId aooId 通常 ios 和安卓不一样
   * @param {String} params.posId posId 通常 ios 和安卓不一样
   * @param {Number} callback 回调函数
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.status  1：广告已经显示  2：已经完成激励时长 3：广告被点击  4：视频播放结束 5：广告被关闭  -1：报错
   *
   * @example <caption>打开视频广告</caption>
   *     var posId = jssdk.isIOS ? "1021000837279066" : "9070268837520422";
   *     var appId = jssdk.isIOS ? 1108248575 : 1108323910;
   * jssdk.app.displayRewardVideo({
   *    appId:appId || 1108248575,
   *    posId:posId || "4090766867324479"
   * }, function(data) {
   *    console.log(JSON.stringify(data));
   *    alert(JSON.stringify(data));
   * });;
   *
   * @support iOS 5.9.378
   * @support android 7.9.378
   * @support harmony 1.0.0
   */

  var displayRewardVideo = {
    "default": function _default(params, callback) {
      invokeClient('app', 'displayRewardVideo', params, callback);
    },
    support: {
      "iOS": "5.9.378",
      "android": "7.9.378",
      "harmony": "1.0.0"
    }
  };
  /**
   * @module app
   * @description 业务相关接口
   */

  var app = {
    addTimerTask: addTimerTask,
    addToBookshelf: addToBookshelf,
    buyChapter: buyChapter,
    buyVolume: buyVolume,
    addLocalNotification: addLocalNotification,
    cancelLocalNotification: cancelLocalNotification,
    queryLocalNotification: queryLocalNotification,
    addReadingProgress: addReadingProgress,
    getEncryptSign: getEncryptSign,
    getLatestBook: getLatestBook,
    getReadingDuration: getReadingDuration,
    getReadingPrefer: getReadingPrefer,
    getRecommendBookListLastShare: getRecommendBookListLastShare,
    isInBookshelf: isInBookshelf,
    getShareUserCode: getShareUserCode,
    isLatestVersion: isLatestVersion,
    open: open,
    openAuthor: openAuthor,
    openBook: openBook,
    openBookComments: openBookComments,
    openBookLastPage: openBookLastPage,
    openBookList: openBookList,
    openBookMonthTicket: openBookMonthTicket,
    openBookRecommendTicket: openBookRecommendTicket,
    openBookReward: openBookReward,
    openBookshelf: openBookshelf,
    openBookStore: openBookStore,
    openBoutiques: openBoutiques,
    openBugFeedback: openBugFeedback,
    openCategory: openCategory,
    openCategorys: openCategorys,
    openChapter: openChapter,
    openDailyReading: openDailyReading,
    openDiscussArea: openDiscussArea,
    openFeedback: openFeedback,
    openFilter: openFilter,
    openFind: openFind,
    openFree: openFree,
    isLogin: isLogin,
    openLogin: openLogin,
    openRank: openRank,
    openReceiveCoin: openReceiveCoin,
    openRecharge: openRecharge,
    openRechargeHistory: openRechargeHistory,
    openRechargeWithChannel: openRechargeWithChannel,
    openRecommendBookList: openRecommendBookList,
    openRecommendBookListComments: openRecommendBookListComments,
    openRecommendBookListSquare: openRecommendBookListSquare,
    openSendRedPacket: openSendRedPacket,
    openSetting: openSetting,
    openSignIn: openSignIn,
    openSubject: openSubject,
    openSweep: openSweep,
    openTask: openTask,
    openUserCenter: openUserCenter,
    queryTimerTask: queryTimerTask,
    removeFromBookshelf: removeFromBookshelf,
    removeTimerTask: removeTimerTask,
    report: report,
    setNavigationRightButton: setNavigationRightButton,
    share: share,
    shareBook: shareBook,
    shareNote: shareNote,
    shareReward: shareReward,
    shareToChannel: shareToChannel,
    shareVote: shareVote,
    showBook: showBook,
    showMore: showMore,
    signIn: signIn,
    unsetNavigationRightButton: unsetNavigationRightButton,
    upgrade: upgrade,
    checkThemeMode: checkThemeMode,
    cashPay: cashPay,
    openInteractionDialog: openInteractionDialog,
    showBatchPurchase: showBatchPurchase,
    queryReceiveCalendarActivity: queryReceiveCalendarActivity,
    saveCalendarActivity: saveCalendarActivity,
    downloadImage: downloadImage,
    getPayChannel: getPayChannel,
    gotoPay: gotoPay,
    launchMiniProgram: launchMiniProgram,
    openTabWebViewWithScrollNavi: openTabWebViewWithScrollNavi,
    setDisallowInterceptTouchRects: setDisallowInterceptTouchRects,
    addBigEmoji: addBigEmoji,
    addedEmojiIds: addedEmojiIds,
    isTryMode: isTryMode,
    shareTo: shareTo,
    startVipPay: startVipPay,
    startVipPaySingleChannel: startVipPaySingleChannel,
    openIAP: openIAP,
    checkAppEnv: checkAppEnv,
    enableVisitorLoginState: enableVisitorLoginState,
    inAppEvaluationNeedShow: inAppEvaluationNeedShow,
    inAppEvaluationState: inAppEvaluationState,
    openInAppEvaluate: openInAppEvaluate,
    reportFingerprint: reportFingerprint,
    shareToDouyin: shareToDouyin,
    getDyAuthCode: getDyAuthCode,
    startVipCouponSelectedDialog: startVipCouponSelectedDialog,
    userInfo: userInfo,
    voteMonthTicket: voteMonthTicket,
    uploadLog: uploadLog,
    consumeCashPay: consumeCashPay,
    openPayInCash: openPayInCash,
    specialDevice: specialDevice,
    openPushPermission: openPushPermission,
    queryPushPermission: queryPushPermission,
    networkEnvironment: networkEnvironment,
    queryAudioPlayStatus: queryAudioPlayStatus,
    operateAudioPlayStatus: operateAudioPlayStatus,
    showRewardVideo: showRewardVideo,
    preloadRewardVideo: preloadRewardVideo,
    putStorageValue: putStorageValue,
    storageValue: storageValue,
    addActivityPost: addActivityPost,
    shareActivityComment: shareActivityComment,
    displayRewardVideo: displayRewardVideo
  };
  /**
   * @method getHeader
   * @description 获取当前设备型号
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {String} callback.data.header 设备信息
   * @param {String} callback.signedData 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signedData.header 签名后的设备信息
   *
   * @example <caption>获取当前设备型号</caption>
   * jssdk.device.getHeader(function (data) {
   *   console.log(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var getHeader = {
    "default": function _default(callback) {
      invokeClient('device', 'getHeader', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    },
    hibridge: null
  };
  /**
   * @method getSystemVersion
   * @description 获取系统版本号
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {String} callback.data.systemVersion 系统版本号
   * @param {String} callback.signedData 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signedData.systemVersion 签名后的系统版本号
   *
   * @example <caption>获取系统版本号</caption>
   * jssdk.device.getSystemVersion(function (data) {
   *    console.log(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var getSystemVersion = {
    "default": function _default(callback) {
      invokeClient('device', 'getSystemVersion', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getVersionCode
   * @description 获取客户端当前服务端版本号
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {String} callback.data.versionCode 客户端当前数字版本号
   * @param {String} callback.signedData 签名后的data(QD android 6.9.3/iOS 4.7.7 新增)
   * @param {String} callback.signedData.versionCode 签名后的客户端当前数字版本号
   *
   * @example <caption>获取客户端当前服务端版本号</caption>
   * jssdk.device.getVersionCode(function (data) {
   *  console.log(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var getVersionCode = {
    "default": function _default(callback) {
      invokeClient('device', 'getVersionCode', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method deviceInfo
   * @description 获取设备的详细信息 manu: 品牌
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   *
   * @example <caption>获取设备的详细信息</caption>
   * jssdk.device.deviceInfo(function (data) {
   *   console.log(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var deviceInfo = {
    "default": function _default(callback) {
      invokeClient('device', 'deviceInfo', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @module device
   * @description 设备相关接口
   */

  var device = {
    getHeader: getHeader,
    getSystemVersion: getSystemVersion,
    getVersionCode: getVersionCode,
    deviceInfo: deviceInfo
  };
  /**
   * @event browserTitleBarClick
   * @description 点击标题栏事件，监听后点击手机标题栏就会收到通知(可以用来实现点击标题滚动到顶部的功能)
   * @param {Function} callback 事件回调
   * @param {Number} callback.result 事件状态(0表示正常)
   * @param {Object} callback.data 事件数据
   *
   * @example <caption>添加事件监听</caption>
   * jssdk.addEventListener("browserTitleBarClick", function(data) {
   *   console.log("Receive event: browserTitleBarClick, data: " + JSON.stringify(data));
   * });
   *
   * @example <caption>移除事件监听</caption>
   * jssdk.removeEventListener('browserTitleBarClick');
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var browserTitleBarClick = {
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @event browserVisibilityChange
   * @description 当前页面可见性更改事件，监听后离开/回到本页面就会收到通知(可以用来实现登录成功之后刷新页面的功能)
   * @param {Function} callback 事件回调
   * @param {Number} callback.result 事件状态(0表示正常)
   * @param {Object} callback.data 事件数据
   * @param {Boolean} callback.data.visibility 页面可见性(true: 可见; false: 不可见)
   * ios 返回的是 visibility字段 安卓返回的是 browserVisibilityChange 字段
   *
   * @example <caption>添加事件监听</caption>
   * jssdk.addEventListener("browserVisibilityChange", function(data) {
   *   console.log("Receive event: browserVisibilityChange, data: " + JSON.stringify(data));
   * });
   *
   * @example <caption>移除事件监听</caption>
   * jssdk.removeEventListener('browserVisibilityChange');
   *
   * @support iOS 3.8.0
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var browserVisibilityChange = {
    support: {
      "iOS": "3.8.0",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @module event
   * @description 事件相关接口
   */

  registerEvent('browserTitleBarClick', browserTitleBarClick);
  registerEvent('browserVisibilityChange', browserVisibilityChange);
  /**
   * @method keyboardWillHideBehavior
   * @description iOS 键盘弹出状态，即将收回时设置不会有下沉上移的情况
   * @param {Object} params 参数
   * @param {Number} params.behavior 0：never（默认） 1：automatic 即iOS默认的（没有下沉的问题）never可以理解为键盘弹出收回不会有下沉上移的情况，automatic 是交给系统自己处理。
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>键盘弹出状态，即将收回时设置不会有下沉上移</caption>
   * jssdk.ui.keyboardWillHideBehavior({
   *   behavior:0
   * });
   *
   * @support iOS 5.9.250
   * @support android 7.9.250
   * @support harmony 1.0.0
   */

  var keyboardWillHideBehavior = {
    "default": function _default(callback) {
      invokeClient('ui', 'keyboardWillHideBehavior', callback);
    },
    support: {
      "iOS": "5.9.250",
      "android": "7.9.250",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method keyboardWillShowBehavior
   * @description iOS 键盘收回状态，即将弹出时，设置为 0 就不会有下沉上移的情况
   * @param {Object} params 参数
   * @param {Number} params.behavior 0：never 1：automatic（默认）
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置键盘弹出时不会下沉上移</caption>
   * jssdk.ui.keyboardWillShowBehavior({
   *   behavior:0
   * });
   *
   * @support iOS 5.9.250
   * @support android 7.9.250
   * @support harmony 1.0.0
   */

  var keyboardWillShowBehavior = {
    "default": function _default(callback) {
      invokeClient('ui', 'keyboardWillShowBehavior', callback);
    },
    support: {
      "iOS": "5.9.250",
      "android": "7.9.250",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setWebViewBounce
   * @description 去除 iOS 边缘弹性滚动的效果
   * @param {Boolean} bounce 是／否, true为可以, false为不可以
   * @example <caption>去除 iOS 边缘弹性滚动的效果</caption>
   * jssdk.ui.setWebViewBounce(window._toggle_ = !window._toggle_, window._toggle_);
   *
   * @support iOS 5.0.0
   * @support harmony 1.0.0
   */

  var setWebViewBounce = {
    "default": function _default(bounce) {
      invokeClient('ui', 'setWebViewBounce', {
        bounce: bounce
      });
    },
    support: {
      "iOS": "5.0.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method alert
   * @description 提示
   * @param {Object} params 设置
   * @param {String} params.title 标题
   * @param {String} params.text 提示信息
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>提示"Hello, QDSDK!"</caption>
   * jssdk.ui.alert({ title: '提示', text: 'Hello, QDSDK!' }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var alert = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'alert', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method confirm
   * @description 确认框
   * @param {Object} params 设置
   * @param {String} params.title 标题
   * @param {String} params.text 确认信息
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.action 动作类型(0: 取消; 1: 确定)
   *
   * @example <caption>确认"确认提示信息"</caption>
   * jssdk.ui.confirm({ title: '确认框', text: '确认提示信息' }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var confirm = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'confirm', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method exit
   * @description 关闭当前页面
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>关闭当前页面</caption>
   * jssdk.ui.exit();
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var exit = {
    "default": function _default(callback) {
      invokeClient('ui', 'exit', callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method openToolbox
   * @description 在底部弹出工具箱
   * @param {Object} params 设置
   * @param {String} params.channels 分享渠道(未安装渠道不显示, 用","分割, 1: 微信朋友圈, 2: 微信好友, 3: QQ好友, 5: 微博)
   * @param {String} params.tools 工具集(用","分割, refresh: 刷新页面, copy: 复制链接)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.response 点击按钮的响应Code(如: 1/3/refresh/copy)
   *
   * @example <caption>弹出"工具箱"</caption>
   * jssdk.ui.openToolbox({
   *   channels: '1,2,3,5',
   *   tools: 'refresh,copy',
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @example <caption>弹出"工具箱"(无微博分享和复制链接)</caption>
   * jssdk.ui.openToolbox({
   *   channels: '1,2,3',
   *   tools: 'refresh',
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 4.1.0
   * @support android 6.6.6
   * @support harmony 1.0.0
   */

  var openToolbox = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'openToolbox', params, callback);
    },
    support: {
      "iOS": "4.1.0",
      "android": "6.6.6",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method popup
   * @description 对话框
   * @param {Object} params 设置
   * @param {String} params.title 标题
   * @param {String} params.text 确认信息
   * @param {Array<String>} params.buttons 按钮数组(例如：['取消', '购买'])
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   * @param {Object} callback.data 回调数据
   * @param {Number} callback.data.action 点击按钮索引
   *
   * @example <caption>弹出"确认提示信息"对话框并且带3个按钮</caption>
   * jssdk.ui.popup({
   *   title: '确认框',
   *   text: '确认提示信息',
   *   buttons: ['按钮1', '取消', '确定'],
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var popup = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'popup', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeader
   * @description 设置顶部导航栏
   * @param {Object} params 设置
   * @param {String} params.title 标题
   * @param {String} params.color 文本颜色(支持HEX|RGBA)
   * @param {String} params.bgColor 背景色(支持HEX|RGBA)
   * @param {Number} params.height 高度
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置头部导航栏</caption>
   * jssdk.ui.setHeader({
   *   title: '白底黑字高度30',
   *   color: '#000',
   *   bgColor: 'rgba(255,255,255,0)',
   *   height: 30,
   * });
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   */

  var setHeader = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'setHeader', params, callback);
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeaderScrollGradient
   * @description 设置顶部导航栏滚动渐变效果
   * @param {Object} params 设置
   * @param {Number} params.height 渐变开始位置
   * @param {Number} params.distance 渐变持续距离
   * @param {String} params.color 渐变结束文本颜色(支持HEX|RGBA)
   * @param {String} params.bgColor 渐变结束背景颜色(支持HEX|RGBA)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置导航栏滚动中渐变为半透明白色</caption>
   * jssdk.ui.setHeaderScrollGradient({
   *   height: 0,
   *   distance: 200,
   *   color: '#fff',
   *   bgColor: 'rgba(0,0,0,.5)',
   * });
   *
   * @example <caption>设置导航栏滚动后渐变为半透明黑色</caption>
   * jssdk.ui.setHeaderScrollGradient({
   *   height: 200,
   *   distance: 0,
   *   color: '#ffffff',
   *   bgColor: 'rgba(0,0,0,.5)',
   * });
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   */

  var setHeaderScrollGradient = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'setHeaderScrollGradient', params, callback);
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeaderLeft
   * @description 自定义顶部导航栏左侧
   * @param {Object} params 设置
   * @param {String} params.icon 显示图标(可配置图标: back|close)
   * @param {String} params.text 显示文本(icon 优先生效, icon 缺省的情况下 text 生效)
   * @param {Function} callback 点击回调函数
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置头部导航栏左侧</caption>
   * jssdk.ui.setHeaderLeft({
    *   icon: 'close',
    *   text: '关闭',
    * });
   *
   * @example <caption>设置头部导航栏左侧(接管回调)</caption>
   * jssdk.ui.setHeaderLeft({
   *   icon: 'close',
   *   text: '关闭',
   * }, function (data) {
   *   alert(JSON.stringify(data));
   *   jssdk.ui.exit();
   * });
   *
   * @support iOS 4.1.0
   * @support android 6.6.6
   * @support harmony 1.0.0
   */

  var setHeaderLeft = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'setHeaderLeft', params, callback);
    },
    support: {
      "iOS": "4.1.0",
      "android": "6.6.6",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeaderLeftV2
   * @description 自定义顶部导航栏左侧 iOS 专用
   * @param {Function} callback 点击回调函数
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置头部导航栏左侧 iOS </caption>
   * jssdk.ui.setHeaderLeftV2();
   *
   * @example <caption>设置头部导航栏左侧 iOS (接管回调)</caption>
   * jssdk.ui.setHeaderLeftV2({},function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.264
   * @support android 5.9.264
   * @support harmony 1.0.0
   */

  var setHeaderLeftV2 = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'setHeaderLeftV2', callback);
    },
    support: {
      "iOS": "5.9.264",
      "android": "5.9.264",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeaderRight
   * @description 自定义顶部导航栏右侧
   * @param {Object} params 设置
   * @param {String} params.icon 显示图标(可配置图标: refresh|share)
   * @param {String} params.text 显示文本(icon 优先生效, icon 缺省的情况下 text 生效)
   * @param {Function} callback 点击回调函数
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置头部导航栏右侧</caption>
   * jssdk.ui.setHeaderRight({
   *   icon: 'share',
   *   text: '分享',
   * }, function (data) {
   *   jssdk.app.share({
   *     title: '斗罗大陆',
   *     desc: '当唐门暗器来到斗罗大陆，当唐三武魂觉醒，他能否在这片武魂的世界再铸唐门的辉煌？他能否成为这个世界的主宰：神?',
   *     imageUrl: 'http://qidian.qpic.cn/qdbimg/349573/1115277/180',
   *     url: 'http://www.qidian.com/Book/1115277.aspx',
   *     channels: '1,2,3,5', // 依次显示分享渠道为：朋友圈，微信好友，QQ好友，微博
   *   }, function (data) {
   *     alert(JSON.stringify(data));
   *   });
   * });
   *
   * @support iOS 4.1.0
   * @support android 6.6.6
   * @support harmony 1.0.0
   */

  var setHeaderRight = {
    "default": function _default(params, callback) {
      if (support('ui.setHeaderRight')) {
        invokeClient('ui', 'setHeaderRight', params, callback);
      } else {
        // 向下兼容
        invokeClient('app', 'setNavigationRightButton', params && params.text, callback);
      }
    },
    support: {
      "iOS": "4.1.0",
      "android": "6.6.6",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method toast
   * @description Toast
   * @param {Object} params 回调方法
   * @param {String} params.text 提示信息
   * @param {Number} params.type 类型(海外v1.1.0新加配置, 1:Info; 2:Confirm; 3:Warning; 4:Alert)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>提示"Hello, QDSDK!"</caption>
   * jssdk.ui.toast('Hello, QDSDK!');
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var toast = {
    "default": function _default(params, callback) {
      // 向下兼容
      if (typeof params === 'string') {
        params = {
          text: params
        };
      }

      invokeClient('ui', 'toast', params, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method toggleRefresh
   * @description 显示／隐藏右上角的刷新按钮
   * @param {Boolean} isShow 显示／隐藏, true为显示, false为隐藏
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>显示/隐藏右上角刷新按钮</caption>
   * jssdk.ui.toggleRefresh(window._toggle_ = !window._toggle_, window._toggle_);
   *
   * @support iOS 3.7.3
   * @support android 6.4.0
   * @support harmony 1.0.0
   */

  var toggleRefresh = {
    "default": function _default(isShow, callback) {
      invokeClient('ui', 'toggleRefresh', {
        isShow: isShow
      }, callback);
    },
    support: {
      "iOS": "3.7.3",
      "android": "6.4.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method unsetHeaderRight
   * @description 移除顶部导航栏右侧
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>移除顶部导航栏右侧</caption>
   * jssdk.ui.unsetHeaderRight();
   *
   * @support iOS 4.0.0
   * @support android 6.6.0
   * @support harmony 1.0.0
   */

  var unsetHeaderRight = {
    "default": function _default(callback) {
      if (support('ui.unsetHeaderRight')) {
        invokeClient('ui', 'unsetHeaderRight', callback);
      } else {
        // 向下兼容
        invokeClient('app', 'unsetNavigationRightButton', callback);
      }
    },
    support: {
      "iOS": "4.0.0",
      "android": "6.6.0",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeaderRightForGame
   * @description 自定义顶部导航栏右侧(游戏)
   * @param {Object} params 设置
   * @param {Array} params.iconList 显示图标(按数组顺序从右往左显示)
   * @param {Function} callback 点击回调函数
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置头部导航栏右侧(游戏)(接管回调)</caption>
   * jssdk.ui.setHeaderRightForGame({
   *   iconList: ['https://qidian.gtimg.com/hongxium/img/activities/download-header-logo-dda168a850.png', 'https://imgservices-1252317822.image.myqcloud.com/image/20210514/2z0zc5ffs6.gif']
   * }, function (data) {
   *   alert(JSON.stringify(data));
   * });
   *
   * @support iOS 5.9.116
   * @support android 7.9.116
   * @support harmony 1.0.0
   */

  var setHeaderRightForGame = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'setHeaderRightForGame', params, callback);
    },
    support: {
      "iOS": "5.9.116",
      "android": "7.9.116",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method getTabHeight
   * @description 获取 App Tab 的高度
   * @param {Function} callback 回调方法
   * @param {Number} callback.tabHeight 回调结果
   *
   * @example <caption>获取 App Tab 的高度</caption>
   * jssdk.ui.getTabHeight();
   * @support iOS 5.9.226
   * @support android 7.9.226
   * @support harmony 1.0.0
   */

  var getTabHeight = {
    "default": function _default(callback) {
      invokeClient('ui', 'getTabHeight', callback);
    },
    support: {
      "iOS": "5.9.226",
      "android": "7.9.226",
      "harmony": "1.0.0"
    }
  };
  /**
   * @method setHeaderScrollGradientV2
   * @description 设置顶部导航栏滚动渐变效果V2（可配合 AppTab 使用）
   * @param {Object} params 参数
   * @param {Number} params.height 渐变开始位置
   * @param {Number} params.distance 渐变持续距离
   * @param {String} params.beginColor 渐变开始文本颜色(支持HEX|RGBA)
   * @param {String} params.beginBgColor 渐变开始背景颜色(支持HEX|RGBA)
   * @param {String} params.color 渐变结束文本颜色(支持HEX|RGBA)
   * @param {String} params.bgColor 渐变结束背景颜色(支持HEX|RGBA)
   * @param {Function} callback 回调方法
   * @param {Number} callback.result 回调状态
   *
   * @example <caption>设置导航栏滚动中渐变从白色到深色（可配合 AppTab 使用）</caption>
   * jssdk.ui.setHeaderScrollGradientV2({
   *   height: 0,
   *   distance: 100,
   *   beginColor:'#000000',
   *   beginBgColor:'rgba(255, 255, 255, 0.8)',
   *   color: '#ffffff',
   *   bgColor: 'rgba(0, 0, 0, 0.8)'
   * });
   *
   * @example <caption>设置导航栏滚动后渐变从深色到白色（可配合 AppTab 使用）</caption>
   * jssdk.ui.setHeaderScrollGradientV2({
   *   height: 0,
   *   distance: 100,
   *   beginColor:'#ffffff',
   *   beginBgColor:'rgba(0, 0, 0, 0.8)',
   *   color: '#000000',
   *   bgColor: 'rgba(255, 255, 255, 0.8)'
   * });
   *
   * @support iOS 5.9.226
   * @support android 7.9.226
   * @support harmony 1.0.0
   */

  var setHeaderScrollGradientV2 = {
    "default": function _default(params, callback) {
      invokeClient('ui', 'setHeaderScrollGradientV2', params, callback);
    },
    support: {
      "iOS": "5.9.226",
      "android": "7.9.226",
      "harmony": "1.0.0"
    }
  };
  /**
   * @module ui
   * @description 界面相关接口
   */

  var ui = {
    keyboardWillHideBehavior: keyboardWillHideBehavior,
    keyboardWillShowBehavior: keyboardWillShowBehavior,
    setWebViewBounce: setWebViewBounce,
    alert: alert,
    confirm: confirm,
    exit: exit,
    openToolbox: openToolbox,
    popup: popup,
    setHeader: setHeader,
    setHeaderScrollGradient: setHeaderScrollGradient,
    setHeaderLeft: setHeaderLeft,
    setHeaderLeftV2: setHeaderLeftV2,
    setHeaderRight: setHeaderRight,
    toast: toast,
    toggleRefresh: toggleRefresh,
    unsetHeaderRight: unsetHeaderRight,
    setHeaderRightForGame: setHeaderRightForGame,
    getTabHeight: getTabHeight,
    setHeaderScrollGradientV2: setHeaderScrollGradientV2
  };
  console.log("当前 jssdk 版本是：4.0.10 请确认使用的是否最新版本");
  jssdk.version = '4.0.10';

  function mountModules(modules) {
    Object.keys(modules).forEach(function (moduleName) {
      var methods = modules[moduleName];
      Object.keys(methods).forEach(function (methodName) {
        mount(moduleName, methodName, methods[methodName]);
      });
    });
  }

  mountModules({
    app: app,
    device: device,
    ui: ui
  }); // 供客户端调用回调方法，例如: execCallback(callbackId, data)

  window.execCallback = execCallback; // 供客户端触发事件，例如: dispatchEvent(eventName, data)

  window.dispatchEvent = dispatchEvent;
  return jssdk;
});
